/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
// Add custom code below this line

  // Header and toolbar sticky behaviour: reads the "Sticky header" /
  // "Sticky toolbar" settings (each: none / mobile / desktop / both)
  // and applies them per current viewport width. Handles all four
  // combinations:
  //   toolbar off, header off  - everything scrolls normally
  //   toolbar off, header on   - header pins once scrolled past the
  //                              toolbar's height; toolbar scrolls away
  //   toolbar on,  header off  - toolbar stays fixed at the top always;
  //                              header scrolls normally beneath it
  //   toolbar on,  header on   - both pin, header docked directly under
  //                              the always-visible toolbar
  function initHeaderPin() {
    var wrapper = document.querySelector('[data-header-wrapper]');
    var toolbar = document.querySelector('[data-header-toolbar]');
    var header = document.querySelector('.theme__header');
    if (!wrapper || !header) return;

    var desktopQuery = window.matchMedia('(min-width: 750px)');
    var naturalToolbarHeight = 0;
    var pinnedHeight = '';
    var barSolid = '';
    var ticking = false;

    function isActiveForDevice(mode) {
      if (!mode || mode === 'none') return false;
      if (mode === 'both') return true;
      var isDesktop = desktopQuery.matches;
      return (mode === 'desktop' && isDesktop) || (mode === 'mobile' && !isDesktop);
    }

    function measure() {
      naturalToolbarHeight = toolbar ? toolbar.offsetHeight : 0;
    }

    function update() {
      var headerMode = wrapper.getAttribute('data-header-sticky-mode');
      var toolbarMode = toolbar ? toolbar.getAttribute('data-toolbar-sticky-mode') : 'none';

      var toolbarPinned = isActiveForDevice(toolbarMode);
      var headerStickyEnabled = isActiveForDevice(headerMode);

      if (toolbar) toolbar.classList.toggle('toolbar--pinned', toolbarPinned);

      // Written to the root only when it changes, and taken off rather than
      // written as 0px (every reader falls back to 0px). A custom property
      // set on the root restyles the whole page, and on phones the scrollY
      // read below would then force that restyle and a layout at once.
      var nextPinnedHeight = toolbarPinned ? naturalToolbarHeight + 'px' : '';
      if (nextPinnedHeight !== pinnedHeight) {
        if (nextPinnedHeight) {
          document.documentElement.style.setProperty('--toolbar-pinned-height', nextPinnedHeight);
        } else {
          document.documentElement.style.removeProperty('--toolbar-pinned-height');
        }
        pinnedHeight = nextPinnedHeight;
      }

      var shouldPinHeader;
      if (!headerStickyEnabled) {
        shouldPinHeader = false;
      } else if (toolbarPinned) {
        // Toolbar never leaves, so the header docks under it immediately.
        shouldPinHeader = true;
      } else {
        shouldPinHeader = window.scrollY >= naturalToolbarHeight;
      }

      // The bar fills in as the page scrolls, where the header stays at the
      // top (phones): clear at the top of the page, solid by 110px, on a
      // smoothstep so it starts and ends gently. custom.css reads it only
      // over a hero under the see-through header, below 1100 (the bar's
      // ground, section 5). Read here, before anything below writes, and
      // written to the header only when it changes, so a write restyles the
      // header alone. Taken off where the header doesn't stay.
      var nextBarSolid = '';
      if (headerStickyEnabled) {
        var travel = Math.min(Math.max(window.scrollY / 110, 0), 1);
        nextBarSolid = String(Math.round(travel * travel * (3 - 2 * travel) * 1000) / 1000);
      }

      header.classList.toggle('header--pinned', shouldPinHeader);

      if (nextBarSolid !== barSolid) {
        if (nextBarSolid) {
          header.style.setProperty('--bar-solid', nextBarSolid);
        } else {
          header.style.removeProperty('--bar-solid');
        }
        barSolid = nextBarSolid;
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    measure();
    update();
    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', function () {
      measure();
      update();
    });
    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', update);
    }
    document.addEventListener('shopify:section:load', function () {
      measure();
      update();
    });
  }

  initHeaderPin();

  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const id = link.getAttribute('href').substring(1);
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        history.pushState(null, null, '#' + id);
        setTimeout(() => {
          history.replaceState(null, null, ' ');
        }, 500);
      }
    });
  });

  /* ----------------------------------------------------------------------
     ?ref= links and cellar door QR sign-ups
     ----------------------------------------------------------------------

     A link's ?ref= goes on the site's cart as acquisition_source, so the
     order shows where the visit came from.

     The cellar door QR code (?ref=cellar-door-qr, on the join page) is the
     exception. WineHub's sign-up never uses the site's cart: at Go to
     checkout it makes its own cart through the Storefront API (a cartCreate
     sent with fetch) and opens that cart's checkout, so nothing on our cart
     reaches a sign-up order. Left on our cart, the QR's ref would only
     reach a later wine order from the same phone, which the order tag
     would then count as a sign-up. So it stays off the site's cart, is
     held for the tab instead (sessionStorage: the QR lands on the join page
     and the sign-up is a page further on), and goes onto a membership at
     the moment someone joins. The site's cart gets only the visit marker,
     cellar_door_qr_scan (below), which WineHub's sign-up carries too:
     - WineHub's sign-up: its own cartCreate gets what WineHub's in-store
       mode adds (the "Enable POS Sign Up" panel the sign-up keeps hidden),
       wh_pos_sign_up "true" and wh_sign_up_location, the Shopify location
       id; the staff member, wh_staff and wh_staff_name, as WineHub's staff
       attribution sends them; WineHub's sales channel, wh_sales_channel_name,
       in place of the "Website" it sends; and acquisition_source for the
       order tag.
     - The cart drawer's club offer: cart-club.js asks
       window.crittendenPosSignUp() for the same on joining, and takes them
       off again on leaving.
     The staff member is WineHub's own POS staff entry and the sales channel
     a custom one made in WineHub for these sign-ups, so WineHub files them
     apart from both website and counter sign-ups. The order's sales channel
     in Shopify stays Online Store whatever is sent: checkout happens on the
     guest's phone.

     The wrapper goes on only for a QR tab and only on a page holding
     WineHub's sign-up, and it changes only a cartCreate carrying
     wh_subscription; a request it can't read goes out untouched. WineHub's
     sign-up script sends the attributes inline, or on a second path as
     variables; the wrapper handles both. If WineHub changes how it builds
     the cart, sign-ups still work: they just stop being marked.
     Location and staff ids are WineHub's own lists
     (customer-portal/subscription/locations and /employee); the sales
     channel is matched by its name in WineHub. */

  var POS_SIGN_UP_REFS = {
    'cellar-door-qr': {
      location: '65117061169',            /* Shopify location: Crittenden */
      staff: '364',                       /* WineHub staff: POS */
      staffName: 'POS',
      channel: 'Website via CD QR Code'   /* WineHub sales channel */
    }
  };
  var POS_SIGN_UP_KEY = 'crittenden_pos_sign_up';
  var QR_SCAN_KEY = 'crittenden_qr_scan';
  /* The visit marker: on every order from a QR visitor, sign-up or not,
     so a website order shows the customer was at the cellar door. Its
     value is the day of the scan, so an order placed days later from the
     same cart reads as such. Kept apart from acquisition_source, which
     only a sign-up carries and the sign-up tag keys on. */
  var QR_SCAN_ATTRIBUTE = 'cellar_door_qr_scan';

  function isPosRef(value) {
    return !!value && Object.prototype.hasOwnProperty.call(POS_SIGN_UP_REFS, value);
  }

  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (ref && !isPosRef(ref)) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { 'acquisition_source': ref }
      })
    });
  }

  /* The day of this tab's QR scan (Melbourne time), set on landing: the
     site's cart gets the visit marker then, so any order from it carries
     it. Without sessionStorage only the landing page knows the day. */
  var qrScanDay = (function () {
    var day = null;
    if (isPosRef(ref)) {
      day = new Date().toLocaleDateString('en-CA', { timeZone: 'Australia/Melbourne' });
      var marker = {};
      marker[QR_SCAN_ATTRIBUTE] = day;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: marker })
      });
    }
    try {
      if (day) sessionStorage.setItem(QR_SCAN_KEY, day);
      day = sessionStorage.getItem(QR_SCAN_KEY) || day;
    } catch (error) {}
    return day;
  })();

  /* This tab's cellar door ref: from the address, else held from earlier
     in the tab. Without sessionStorage only the landing page knows it. */
  var posRef = (function () {
    var held = null;
    try {
      if (isPosRef(ref)) sessionStorage.setItem(POS_SIGN_UP_KEY, ref);
      held = sessionStorage.getItem(POS_SIGN_UP_KEY);
    } catch (error) {
      held = ref;
    }
    return isPosRef(held) ? held : null;
  })();

  /* What goes on a membership started in this tab, or null when the tab
     didn't come from the QR code. A new object each call, keys in the order
     they're sent. */
  function posSignUpAttributes() {
    if (!posRef) return null;
    var how = POS_SIGN_UP_REFS[posRef];
    return {
      wh_pos_sign_up: 'true',
      wh_sign_up_location: how.location,
      wh_staff: how.staff,
      wh_staff_name: how.staffName,
      wh_sales_channel_name: how.channel,
      acquisition_source: posRef
    };
  }

  window.crittendenPosSignUp = posSignUpAttributes;

  function initPosSignUp() {
    var attrs = posSignUpAttributes();
    if (!attrs) return;
    if (!document.querySelector('.wine-subscription-app')) return;
    if (!window.fetch || window.fetch.posSignUp) return;

    var extra = Object.keys(attrs).map(function (key) { return [key, attrs[key]]; });
    if (qrScanDay) extra.push([QR_SCAN_ATTRIBUTE, qrScanDay]);

    function mark(body) {
      var data = JSON.parse(body);
      var query = data && typeof data.query === 'string' ? data.query : '';
      var start = query.indexOf('cartCreate');
      if (start === -1) return body;

      var list = data.variables && data.variables.attributes;
      if (Array.isArray(list)) {
        var has = function (key) {
          return list.some(function (item) { return item && item.key === key; });
        };
        if (!has('wh_subscription')) return body;
        extra.forEach(function (pair) {
          var same = list.filter(function (item) { return item && item.key === pair[0]; });
          if (same.length) same.forEach(function (item) { item.value = pair[1]; });
          else list.push({ key: pair[0], value: pair[1] });
        });
        return JSON.stringify(data);
      }

      var open = /attributes\s*:\s*\[/.exec(query.slice(start));
      if (!open || !/key\s*:\s*"wh_subscription"/.test(query)) return body;
      extra.forEach(function (pair) {
        query = query.replace(new RegExp('\\{\\s*key\\s*:\\s*"' + pair[0] + '"\\s*,\\s*value\\s*:\\s*"(?:[^"\\\\]|\\\\.)*"\\s*\\}\\s*,?', 'g'), '');
      });
      var insert = extra.map(function (pair) {
        return '{ key: ' + JSON.stringify(pair[0]) + ', value: ' + JSON.stringify(pair[1]) + ' },';
      }).join('\n');
      open = /attributes\s*:\s*\[/.exec(query.slice(start));
      var at = start + open.index + open[0].length;
      data.query = query.slice(0, at) + '\n' + insert + query.slice(at);
      return JSON.stringify(data);
    }

    var nativeFetch = window.fetch;
    var wrapped = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (init && typeof init.body === 'string' && /\/api\/[^\/]+\/graphql\.json/.test(url)) {
          var body = mark(init.body);
          if (body !== init.body) init = Object.assign({}, init, { body: body });
        }
      } catch (error) {}
      return nativeFetch.call(window, input, init);
    };
    wrapped.posSignUp = true;
    window.fetch = wrapped;
  }

  initPosSignUp();

  /* WineHub's sign-up app scrolls itself into view once its wines load, a
     few seconds after the page opens. Its scrolls are ignored until the
     visitor uses the app, so moving between its steps still scrolls. */
  function initSignUpLanding() {
    var app = document.querySelector('.wine-subscription-app');
    if (!app || typeof Element.prototype.scrollIntoView !== 'function') return;

    var native = Element.prototype.scrollIntoView;
    var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var started = false;

    function start(event) {
      if (event.isTrusted) started = true;
    }
    app.addEventListener('click', start, true);
    app.addEventListener('keydown', start, true);

    Element.prototype.scrollIntoView = function (options) {
      if (!app.contains(this)) return native.apply(this, arguments);
      if (!started) return;
      if (reduced && reduced.matches && options && typeof options === 'object') {
        return native.call(this, Object.assign({}, options, { behavior: 'instant' }));
      }
      return native.apply(this, arguments);
    };
  }

  initSignUpLanding();



  // The toolbar is deliberately rendered outside <header-component> to stop
  // position:fixed descendants getting trapped by its transform (see the
  // sticky header and toolbar code above). Side effect: theme.js's own
  // cartToggleEvent() only binds [data-cart-toggle] elements that are
  // descendants of <header-component>, so the toolbar's cart icon would
  // otherwise fall back to a plain /cart navigation. Replicate the same
  // handler for it here, and for the cart in the WineHub portal's own
  // header on phones (snippets/winehub-portal-bar.liquid), which is outside
  // it too.
  function initToolbarCartToggle() {
    if (typeof theme === 'undefined' || theme.settings.cartType !== 'drawer') return;

    document.querySelectorAll('.toolbar__utilities [data-cart-toggle], .whpb [data-cart-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        e.preventDefault();
        cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
        if (window.a11y) window.a11y.lastElement = link;
      });
    });
  }

  initToolbarCartToggle();


  // The WineHub portal's Back (winehub-portal.js, initBackToSite) returns a
  // member to the page they left for the portal. Signed out, the way there
  // is the sign-in, which leaves no page behind it for the portal to read,
  // so a link to the portal, or to the sign-in that returns to it, keeps
  // this page for the visit (sessionStorage, whpb-back). The portal decides
  // whether to use it, and its own pages keep theirs. It listens as the
  // click comes down, so a handler on the link that stops it still lets it
  // through.
  function initPortalReturn() {
    if (location.pathname.indexOf('/apps/winehub') === 0) return;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || link.origin !== location.origin) return;
      var portal = link.pathname.indexOf('/apps/winehub') === 0;
      if (!portal && link.pathname.indexOf('/customer_authentication') === 0) {
        try {
          portal = (new URL(link.href).searchParams.get('return_to') || '').indexOf('/apps/winehub') === 0;
        } catch (error) {}
      }
      if (!portal) return;
      try {
        sessionStorage.setItem('whpb-back', JSON.stringify({ page: location.pathname + location.search, at: Date.now() }));
      } catch (error) {}
    }, true);
  }

  initPortalReturn();


  // Cart: keep focus on the control that was used.
  // theme.js redraws the cart's wines after every quantity change or removal
  // by replacing the contents of [data-items-holder], which destroys the
  // focused control and drops focus to the page behind the drawer. This
  // remembers which control on which wine had focus and puts it back on the
  // same control of the same wine once the redraw fires theme:cart:change.
  // If that wine is gone, focus goes to the wine that took its place (its
  // title, not its Remove, so a held key can't clear the cart), then to the
  // close button. It only acts when focus was actually lost.
  function initCartFocusKeeper() {
    var CONTROLS = [
      'button[name="decrease"]',
      'button[name="increase"]',
      'input[name="updates[]"]',
      '[data-item-remove]'
    ];
    var last = null;

    document.addEventListener('focusin', function (event) {
      var target = event.target;
      var holder = target.closest && target.closest('[data-items-holder]');
      var item = holder && target.closest('[data-item]');
      var control = null;

      if (item) {
        CONTROLS.forEach(function (selector) {
          if (!control && target.matches(selector)) control = selector;
        });
      }

      if (!control) {
        last = null;
        return;
      }

      last = {
        holder: holder,
        key: item.getAttribute('data-item'),
        index: Array.prototype.indexOf.call(holder.querySelectorAll('[data-item]'), item),
        control: control
      };
    });

    document.addEventListener('theme:cart-drawer:close', function () {
      last = null;
    });

    document.addEventListener('theme:cart:change', function () {
      if (!last) return;
      var remembered = last;

      // Let theme.js finish the redraw (it re-enables the controls after
      // firing this event) before moving focus.
      requestAnimationFrame(function () {
        var active = document.activeElement;
        if (active && active !== document.body && document.contains(active)) return;

        var drawer = remembered.holder.closest('cart-drawer');
        if (drawer && !drawer.classList.contains('is-open')) return;

        var item = remembered.holder.querySelector('[data-item="' + CSS.escape(remembered.key) + '"]');
        var target = item && item.querySelector(remembered.control);

        if (!target) {
          var items = remembered.holder.querySelectorAll('[data-item]');
          var next = items[Math.min(remembered.index, items.length - 1)];
          target = next && next.querySelector('.cart__item__title a');
        }

        if (!target && drawer) target = drawer.querySelector('[data-cart-drawer-close]');
        if (target) target.focus();
      });
    });
  }

  initCartFocusKeeper();


  // Cart: "Sign in for your pricing" brings the member back to their cart.
  // The link in the drawer's sign-in line leaves the store for the login
  // page and returns to the page it was clicked on. The flag set on click
  // reopens the drawer there, but only once the customer is signed in, so
  // an abandoned sign-in just clears it.
  function initCartSignInReturn() {
    var KEY = 'cart-drawer-reopen';

    document.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('[data-cart-signin]')) return;
      try { sessionStorage.setItem(KEY, '1'); } catch (error) {}
    });

    var pending = null;
    try {
      pending = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY);
    } catch (error) {}

    if (!pending || !document.body.classList.contains('customer-logged-in')) return;
    if (typeof theme === 'undefined' || theme.settings.cartType !== 'drawer') return;

    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // A short wait for theme.js to finish setting up the drawer.
    setTimeout(function () {
      cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
    }, 200);
  }

  initCartSignInReturn();


  // Cart: gift cards don't count toward free shipping.
  // theme.js redraws the free shipping bar from the cart's whole total after
  // every cart change. Each redraw ends with theme:product:added, and this
  // runs after it, setting the bar again from data-ship-total (cart-price,
  // free-shipping-total.liquid): the total less anything that doesn't ship.
  // The figures and the circle's maths are theme.js's own (updateProgress).
  function initFreeShippingTotal() {
    function sync() {
      var source = document.querySelector('[data-ship-total]');
      if (!source || typeof theme === 'undefined' || !theme.formatMoney) return;
      var total = parseInt(source.getAttribute('data-ship-total'), 10) || 0;
      var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
      var circumference = 28 * Math.PI;

      document.querySelectorAll('[data-free-shipping]').forEach(function (bar) {
        var limit = Number(bar.getAttribute('data-free-shipping-limit')) * 100 * rate;
        if (!limit) return;
        var percent = Math.min((total / limit) * 100, 100);

        var left = bar.querySelector('[data-left-to-spend]');
        if (left) left.innerHTML = theme.formatMoney(limit - total, theme.moneyFormat).replace('.00', '');

        var progress = bar.querySelector('[data-progress-bar]');
        if (progress) progress.value = percent;

        var graph = bar.querySelector('[data-progress-graph]');
        if (graph) graph.style.setProperty('--stroke-dashoffset', String(circumference - ((percent / 100) * circumference) / 2));

        bar.classList.toggle('is-success', bar.getAttribute('data-free-shipping') === 'true' && total >= limit);
      });
    }

    document.addEventListener('theme:product:added', sync);
    document.addEventListener('theme:announcement:init', sync);
  }

  initFreeShippingTotal();


  // Cart: hold quantity taps together.
  // The theme sends a cart update and redraws the cart on every tap of + or
  // -, so going from one bottle to six would take five requests and five
  // redraws. Here the number moves straight away and the cart follows once,
  // half a second after the last tap. Typing a number updates on the spot,
  // holding + or - runs the count up or down, and Check out sends anything
  // still waiting before it leaves.
  function initCartQuantityBatching() {
    var WAIT = 500;
    var HOLD_AFTER = 400;
    var HOLD_EVERY = 110;
    var waiting = {};
    var repeat = null;

    function send(key) {
      var counter = document.querySelector('[data-items-holder] [data-item="' + CSS.escape(key) + '"] quantity-counter');
      var field = counter && counter.querySelector('input[name="updates[]"]');
      if (!field) return;
      counter.dispatchEvent(new CustomEvent('theme:cart:update', {
        bubbles: true,
        detail: { id: key, quantity: field.value, batched: true }
      }));
    }

    function flush() {
      Object.keys(waiting).forEach(function (key) {
        clearTimeout(waiting[key]);
        delete waiting[key];
        send(key);
      });
    }

    function stopRepeat() {
      clearTimeout(repeat);
      clearInterval(repeat);
      repeat = null;
    }

    // Caught on the way down, before the theme's own listener on the line.
    document.addEventListener('theme:cart:update', function (event) {
      var detail = event.detail || {};
      var counter = event.target;
      if (detail.batched || !detail.id || !counter.closest || !counter.closest('[data-items-holder]')) return;
      event.stopPropagation();
      clearTimeout(waiting[detail.id]);
      // Down to 0 the wine is coming out (a phone's bin): no wait.
      if (Number(detail.quantity) <= 0) {
        delete waiting[detail.id];
        send(detail.id);
        return;
      }
      waiting[detail.id] = setTimeout(function () {
        delete waiting[detail.id];
        send(detail.id);
      }, WAIT);
    }, true);

    // Check out with a tap still waiting: the click is held, the tap goes,
    // and the click comes again once the cart has redrawn. theme.js announces
    // the redraw (theme:cart:change) while its buttons are still disabled,
    // and a disabled button ignores a click, so the click waits for the end
    // of that turn; clicked at once it would do nothing, and Check out would
    // need a second press. Anything else pressed in the meantime calls it
    // off: if the update fails and nothing redraws, the next thing pressed
    // clears the held click, so it can't go off on some later redraw.
    var resume = null;

    document.addEventListener('click', function (event) {
      var checkout = event.target.closest && event.target.closest('.cart__checkout, [name="checkout"]');
      if (!checkout || !Object.keys(waiting).length) return;
      event.preventDefault();
      resume = checkout;
      flush();
    }, true);

    document.addEventListener('theme:cart:change', function () {
      var checkout = resume;
      resume = null;
      if (!checkout) return;
      setTimeout(function () {
        if (document.contains(checkout) && !checkout.disabled) checkout.click();
      }, 0);
    });

    ['pointerdown', 'keydown'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (!resume) return;
        if (event.target.closest && event.target.closest('.cart__checkout, [name="checkout"]')) return;
        resume = null;
      }, true);
    });

    document.addEventListener('theme:cart-drawer:close', flush);

    document.addEventListener('pointerdown', function (event) {
      var button = event.target.closest && event.target.closest('.cart__quantity button');
      if (!button || !button.closest('[data-items-holder]')) return;
      stopRepeat();
      repeat = setTimeout(function () {
        repeat = setInterval(function () {
          if (button.disabled || !document.contains(button)) return stopRepeat();
          // Holding − counts down to one bottle and stops: taking the wine
          // out is a tap of its own.
          var field = button.closest('quantity-counter').querySelector('input[name="updates[]"]');
          if (button.name === 'decrease' && field && Number(field.value) <= 1) return stopRepeat();
          button.click();
        }, HOLD_EVERY);
      }, HOLD_AFTER);
    });

    ['pointerup', 'pointercancel', 'pointerleave', 'dragstart'].forEach(function (name) {
      document.addEventListener(name, stopRepeat, true);
    });
  }

  initCartQuantityBatching();

  // The drawer's number opens a list of the usual quantities (a native
  // select over it, cart-line-items.liquid). A choice goes into the hidden
  // field and is sent as a typed number is, through the field's change and
  // the batching above; + and - move the number and the list with them. A
  // quantity the list doesn't hold (13 by the +) is added in its place, so
  // the list always shows what's in the cart.
  function initCartQuantityPick() {
    // From a change until the cart redraws (half a second's wait, then
    // Shopify's reply), the wine's total and the subtotal are dimmed, so a
    // figure that hasn't caught up yet doesn't read as final. The redraw
    // brings fresh lines, and the subtotal's redraw lifts its dimming; if an
    // update fails and nothing redraws, it lifts after 8 seconds.
    var lift = null;

    function clear() {
      clearTimeout(lift);
      Array.prototype.forEach.call(document.querySelectorAll('.cd-updating, .cart__item.is-updating'), function (el) {
        el.classList.remove('cd-updating', 'is-updating');
      });
    }

    // Once the new figures are in, a screen reader hears them: the wine, its
    // quantity and total, and the subtotal, from a polite live region kept
    // outside the parts the cart redraws.
    var pending = null;

    function announce() {
      var change = pending;
      pending = null;
      if (!change || !document.contains(change.root)) return;
      var line = change.root.querySelector('[data-item="' + CSS.escape(change.key) + '"]');
      if (!line) return;
      var tidy = function (el) { return el ? el.innerText.replace(/\s+/g, ' ').trim() : ''; };
      var field = line.querySelector('input[name="updates[]"]');
      var total = change.root.querySelector('.cart__total__price');
      var words = tidy(line.querySelector('.cart__item__title')) + ', quantity ' + (field ? field.value : '') + ', ' +
        tidy(line.querySelector('.cart__price')) + (total ? '. Subtotal ' + tidy(total) + '.' : '');
      var region = change.root.querySelector(':scope > .cd-said');
      if (!region) {
        region = document.createElement('div');
        region.className = 'cd-said visually-hidden';
        region.setAttribute('aria-live', 'polite');
        change.root.appendChild(region);
      }
      region.textContent = words;
    }

    function updating(counter) {
      var line = counter.closest('.cart__item');
      var root = counter.closest('#cart-drawer, [data-cart-page]');
      if (line) line.classList.add('is-updating');
      if (root) root.classList.add('cd-updating');
      if (line && root) pending = { root: root, key: line.getAttribute('data-item') };
      clearTimeout(lift);
      lift = setTimeout(clear, 8000);
    }

    document.addEventListener('theme:cart:change', clear);
    // theme:cart:change can come before or after the subtotal's own redraw,
    // which is the moment the new figures are in.
    if (window.MutationObserver) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-price-holder]'), function (holder) {
        new MutationObserver(function () {
          if (pending) announce();
          clear();
        }).observe(holder, { childList: true, subtree: true });
      });
    }

    function show(counter, value) {
      var pick = counter.querySelector('.cart__quantity-pick');
      if (!pick) return;
      var shown = pick.querySelector('.cart__quantity-pick__value');
      var select = pick.querySelector('select');
      if (shown) shown.textContent = value;
      if (!select || select.value === value) return;
      var number = Number(value);
      var options = Array.prototype.slice.call(select.options);
      var match = options.filter(function (option) { return option.value === value; })[0];
      if (!match && number > 0) {
        match = new Option(value, value);
        var after = options.filter(function (option) { return Number(option.value) > number; })[0];
        select.insertBefore(match, after || null);
      }
      if (match) select.value = value;
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target.closest) return;
      var counter = target.closest('quantity-counter');
      if (!counter || !counter.closest('[data-items-holder]')) return;
      var field = counter.querySelector('input[name="updates[]"]');
      if (!field) return;
      if (target.matches('[data-quantity-pick]') || target === field) {
        counter.classList.toggle('is-last', Number(target.value) <= 1);
      }
      if (target === field) updating(counter);
      if (target.matches('[data-quantity-pick]')) {
        show(counter, target.value);
        if (field.value === target.value) return;
        field.value = target.value;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (target === field) {
        show(counter, field.value);
      }
    });
  }

  initCartQuantityPick();

  // The cart redraws its wines after every change, and each redraw brings a
  // new photo element: blank until it loads, then the theme fades it in over
  // half a second, so the bottles blinked on every quantity change. Here a
  // redrawn wine whose photo is the same file as before gets the photo
  // element it had, already drawn, in place of the new one. The swap runs in
  // the same task as the redraw, before the next frame, so the bottle never
  // leaves. A wine new to the cart keeps the theme's fade. Watched on the
  // cart's own wine lists only (the drawer and /cart).
  function initCartPhotoKeep() {
    var holders = document.querySelectorAll('[data-items-holder]');
    if (!holders.length || !window.MutationObserver) return;

    function photos(nodes) {
      var found = [];
      nodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('.cart__item__image img')) found.push(node);
        found.push.apply(found, node.querySelectorAll('.cart__item__image img'));
      });
      return found;
    }

    Array.prototype.forEach.call(holders, function (holder) {
      new MutationObserver(function (records) {
        var gone = [];
        var added = [];
        records.forEach(function (record) {
          gone.push.apply(gone, photos(Array.prototype.slice.call(record.removedNodes)));
          added.push.apply(added, photos(Array.prototype.slice.call(record.addedNodes)));
        });
        if (!gone.length || !added.length) return;
        var drawn = {};
        gone.forEach(function (img) {
          if (img.complete && img.naturalWidth && !img.classList.contains('is-loading')) drawn[img.getAttribute('src')] = img;
        });
        added.forEach(function (img) {
          var old = drawn[img.getAttribute('src')];
          if (!old || !img.parentNode) return;
          delete drawn[img.getAttribute('src')];
          img.parentNode.replaceChild(old, img);
          var wrap = old.closest('.lazy-image');
          if (wrap) wrap.classList.remove('is-loading');
        });
      }).observe(holder, { childList: true, subtree: true });
    });
  }

  initCartPhotoKeep();

  // The number (the drawer's and /cart's) opens its own list, not the
  // browser's menu or a phone's picker, which take the narrow number's width
  // or the foot of the screen and can't be laid out: this one is the
  // stepper's width, numbers centred, nine rows showing and the rest a
  // scroll away, the wine's quantity marked and in view. The rows are the
  // select's options, so a quantity + added is in it, and a choice goes
  // through the select (initCartQuantityPick). Mouse, touch, arrows, Page Up
  // and Down, Home, End, Enter, Space, Escape; Tab closes it. A mouse opens
  // it on mousedown, as a menu does; a touch on the tap, as the select takes
  // no touches there (custom.css), so a swipe across the number still
  // scrolls. It stays inside the wine list's visible area, opening upward
  // when there's more room above, and joins the stepper: the stepper's edge
  // is the line between them.
  function initCartQuantityList() {
    var VISIBLE = 9;
    var list = null;
    var select = null;
    var drawer = null;
    var active = -1;
    var lastPointer = 'mouse';

    function rows() {
      return list ? list.querySelectorAll('[role="option"]') : [];
    }

    function setActive(index, reveal) {
      var all = rows();
      if (!all.length) return;
      index = Math.max(0, Math.min(all.length - 1, index));
      if (all[active]) all[active].classList.remove('is-active');
      active = index;
      all[index].classList.add('is-active');
      list.setAttribute('aria-activedescendant', all[index].id);
      if (!reveal) return;
      var row = all[index];
      if (row.offsetTop < list.scrollTop) list.scrollTop = row.offsetTop;
      else if (row.offsetTop + row.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = row.offsetTop + row.offsetHeight - list.clientHeight;
    }

    function close(refocus) {
      if (!list) return;
      var was = select;
      var stepper = was && was.closest('.cart__quantity');
      if (stepper) stepper.classList.remove('is-listing');
      list.remove();
      document.removeEventListener('scroll', onScroll, true);
      document.removeEventListener('pointerdown', onOutside, true);
      window.removeEventListener('resize', onResize);
      list = null;
      select = null;
      active = -1;
      if (refocus && was && document.contains(was)) was.focus({ preventScroll: true });
    }

    function choose(index) {
      var row = rows()[index];
      var was = select;
      close(true);
      if (!row || !was || was.value === row.getAttribute('data-value')) return;
      was.value = row.getAttribute('data-value');
      was.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function onScroll(event) {
      if (event.target !== list) close(false);
    }

    // A press on the number it opened from is left to the opening handlers,
    // which close it again.
    function onOutside(event) {
      if (!list || list.contains(event.target)) return;
      if (select && event.target.closest && event.target.closest('.cart__quantity-pick') === select.closest('.cart__quantity-pick')) return;
      close(false);
    }

    function onResize() {
      close(false);
    }

    // The part of the drawer the wines scroll in: the list stays inside it,
    // clear of the drawer's head and its pinned foot. The wine list itself is
    // only as tall as its wines, so with one or two in the cart it would
    // leave the list no room.
    function scroller(from) {
      for (var el = from; el && el !== document.body; el = el.parentElement) {
        var y = getComputedStyle(el).overflowY;
        if (y === 'auto' || y === 'scroll') return el;
      }
      return null;
    }

    // Placed against the stepper, within the wine list's visible area. A
    // fixed box inside a transformed drawer is placed against the drawer
    // instead of the window, so where it lands is measured once and the
    // difference taken off.
    function place() {
      var box = select.closest('.cart__quantity').getBoundingClientRect();
      var view = scroller(select.closest('[data-items-holder]'));
      var area = view ? view.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };
      var below = area.bottom - box.bottom;
      var above = box.top - area.top;
      list.style.width = box.width + 'px';
      list.style.left = '0px';
      list.style.top = '0px';
      var full = list.offsetHeight;
      var down = below >= full || below >= above;
      var room = down ? below : above;
      if (full > room) list.style.maxHeight = Math.max(room, 0) + 'px';
      var height = list.offsetHeight;
      var origin = list.getBoundingClientRect();
      list.style.left = (box.left - origin.left) + 'px';
      list.style.top = ((down ? box.bottom : box.top - height) - origin.top) + 'px';
      list.classList.add(down ? 'is-below' : 'is-above');
    }

    function open(target) {
      close(false);
      select = target;
      drawer = target.closest('#cart-drawer, [data-cart-page]');
      list = document.createElement('div');
      list.className = 'cd-qty-list';
      list.id = 'cd-qty-list';
      list.tabIndex = -1;
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', target.getAttribute('aria-label') || '');
      list.style.setProperty('--cd-qty-visible', VISIBLE);
      var current = 0;
      Array.prototype.forEach.call(target.options, function (option, index) {
        var row = document.createElement('div');
        row.id = 'cd-qty-list-' + index;
        row.setAttribute('role', 'option');
        row.setAttribute('data-value', option.value);
        var chosen = option.value === target.value;
        row.setAttribute('aria-selected', chosen ? 'true' : 'false');
        if (chosen) current = index;
        row.textContent = option.textContent;
        list.appendChild(row);
      });
      // Inside the drawer's dialog: above its content, and inside the focus
      // the drawer holds.
      (target.closest('[data-cart-drawer-inner]') || drawer).appendChild(list);
      place();
      list.classList.add('is-open');
      target.closest('.cart__quantity').classList.add('is-listing');
      setActive(current, false);
      var row = rows()[current];
      list.scrollTop = Math.max(0, row.offsetTop - (list.clientHeight - row.offsetHeight) / 2);
      list.focus({ preventScroll: true });

      list.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'ArrowDown') setActive(active + 1, true);
        else if (key === 'ArrowUp') setActive(active - 1, true);
        else if (key === 'PageDown') setActive(active + VISIBLE, true);
        else if (key === 'PageUp') setActive(active - VISIBLE, true);
        else if (key === 'Home') setActive(0, true);
        else if (key === 'End') setActive(rows().length - 1, true);
        else if (key === 'Enter' || key === ' ') choose(active);
        else if (key === 'Escape') { close(true); event.stopPropagation(); }
        else if (key === 'Tab') close(true);
        else return;
        event.preventDefault();
      });
      list.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse') return;
        var hit = event.target.closest('[role="option"]');
        if (hit) setActive(Array.prototype.indexOf.call(rows(), hit), false);
      });
      list.addEventListener('click', function (event) {
        var hit = event.target.closest('[role="option"]');
        if (hit) choose(Array.prototype.indexOf.call(rows(), hit));
      });
      document.addEventListener('scroll', onScroll, true);
      document.addEventListener('pointerdown', onOutside, true);
      window.addEventListener('resize', onResize);
    }

    function pick(event) {
      return event.target.closest && event.target.closest('#cart-drawer [data-quantity-pick], [data-cart-page] [data-quantity-pick]');
    }

    document.addEventListener('pointerdown', function (event) {
      lastPointer = event.pointerType || 'mouse';
    }, true);

    // The browser opens its menu on mousedown: held back for a mouse.
    document.addEventListener('mousedown', function (event) {
      var target = pick(event);
      if (!target || lastPointer !== 'mouse' || event.button !== 0) return;
      event.preventDefault();
      if (list && select === target) close(true);
      else open(target);
    }, true);

    document.addEventListener('click', function (event) {
      // A select that took the touch itself (a touch screen on a computer)
      // has opened the browser's picker already.
      if (lastPointer === 'mouse' || !event.target.closest || event.target.matches('[data-quantity-pick]')) return;
      var holder = event.target.closest('#cart-drawer .cart__quantity-pick, [data-cart-page] .cart__quantity-pick');
      var target = holder && holder.querySelector('[data-quantity-pick]');
      if (!target) return;
      event.preventDefault();
      if (list && select === target) close(false);
      else open(target);
    });

    document.addEventListener('keydown', function (event) {
      var target = pick(event);
      if (!target) return;
      if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].indexOf(event.key) === -1) return;
      event.preventDefault();
      open(target);
    }, true);

    document.addEventListener('theme:cart-drawer:close', function () {
      close(false);
    });
    document.addEventListener('theme:cart:change', function () {
      close(false);
    });
  }

  initCartQuantityList();

  // A quantity change took two trips: theme.js posts the change, waits for
  // it, then asks for the redrawn wine list (?section_id=api-cart-items),
  // about 0.4s more. Shopify can send that section back with the change
  // itself, so the change asks for it (sections, rendered as on /cart, as
  // the second request is) and the theme's second request is answered from
  // it. Only the theme's own line changes take this path (a body with
  // line), and only the next section request within a few seconds is
  // answered: anything else that changes the cart in between (an add, the
  // club offer's changes) drops it, and an answer without the section falls
  // back to asking. theme.js can't be edited, so its fetch is met here.
  function initCartOneTrip() {
    if (!window.fetch || !window.Response || !window.theme || !theme.routes) return;
    var SECTION = 'api-cart-items';
    var KEEP_MS = 4000;
    var send = window.fetch.bind(window);
    var held = null;
    var heldAt = 0;

    function path(input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      try {
        return new URL(url, location.href);
      } catch (error) {
        return null;
      }
    }

    function isChange(url) {
      return /\/cart\/change(\.js)?$/.test(url.pathname);
    }

    window.fetch = function (input, init) {
      var url = path(input);
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (!url || url.origin !== location.origin) return send(input, init);

      if (method === 'POST' && isChange(url) && init && typeof init.body === 'string') {
        var body = null;
        try {
          body = JSON.parse(init.body);
        } catch (error) {
          body = null;
        }
        if (body && body.line != null) {
          body.sections = SECTION;
          body.sections_url = theme.routes.cart_url;
          var changed = {};
          for (var key in init) changed[key] = init[key];
          changed.body = JSON.stringify(body);
          held = null;
          return send(input, changed).then(function (response) {
            held = response.clone().json().then(function (data) {
              return (data && data.sections && data.sections[SECTION]) || null;
            }, function () {
              return null;
            });
            heldAt = Date.now();
            return response;
          });
        }
      }

      if (method === 'GET' && url.searchParams.get('section_id') === SECTION && held && Date.now() - heldAt < KEEP_MS) {
        var waiting = held;
        held = null;
        return waiting.then(function (html) {
          if (!html) return send(input, init);
          return new Response(html, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
        });
      }

      if (method !== 'GET' && /\/cart\//.test(url.pathname)) held = null;
      return send(input, init);
    };
  }

  initCartOneTrip();

  // Taking a wine out, with − at one bottle (the bin on a phone) or Remove,
  // is a single tap, so the cart (the drawer or /cart) offers it back: where
  // the wine was, "Removed" and its name with Undo, for eight seconds, or
  // until the cart next redraws. Undo adds back the bottles it had and
  // redraws the cart. The line is a polite live region, so a screen reader
  // hears it, and focus moves to Undo, as the control it was on has gone.
  function initCartUndo() {
    var SHOW_MS = 8000;
    var taken = null;
    var notice = null;
    var hide = null;

    function dismiss() {
      clearTimeout(hide);
      if (notice && notice.parentNode) notice.parentNode.removeChild(notice);
      notice = null;
    }

    document.addEventListener('click', function (event) {
      var minus = event.target.closest && event.target.closest('#cart-drawer :is(.cart__quantity-minus, [data-item-remove]), [data-cart-page] :is(.cart__quantity-minus, [data-item-remove])');
      if (!minus) return;
      var counter = minus.closest('quantity-counter');
      var field = counter && counter.querySelector('input[name="updates[]"]');
      var line = minus.closest('[data-item]');
      var removing = minus.hasAttribute('data-item-remove');
      if (!field || !line || (!removing && Number(field.value) > 1)) return;
      var title = line.querySelector('.cart__item__title');
      var lines = Array.prototype.slice.call(line.parentNode.children);
      taken = {
        root: minus.closest('#cart-drawer') ? '#cart-drawer' : '[data-cart-page]',
        key: line.getAttribute('data-item'),
        id: Number(String(line.getAttribute('data-item')).split(':')[0]),
        title: title ? title.textContent.trim() : '',
        quantity: Math.max(1, Number(field.value) || 1),
        index: lines.indexOf(line),
        at: Date.now()
      };
    }, true);

    document.addEventListener('theme:cart:change', function () {
      var wine = taken;
      taken = null;
      if (!wine || Date.now() - wine.at > 10000) return;
      var root = document.querySelector(wine.root);
      if (!root || root.querySelector('[data-item="' + CSS.escape(wine.key) + '"]')) return;
      dismiss();

      var list = root.querySelector('[data-items-holder] .cart__lines');
      var empty = root.querySelector('.drawer__empty__inner, .cart__empty');
      notice = document.createElement(list ? 'li' : 'div');
      notice.className = 'cd-removed';
      notice.setAttribute('aria-live', 'polite');
      var text = document.createElement('p');
      text.className = 'cd-removed__text';
      text.textContent = 'Removed ' + wine.title + '.';
      var undo = document.createElement('button');
      undo.type = 'button';
      undo.className = 'cd-link cd-removed__undo';
      undo.textContent = 'Undo';
      notice.appendChild(text);
      notice.appendChild(undo);

      if (list) list.insertBefore(notice, list.children[wine.index] || null);
      else if (empty) empty.insertBefore(notice, empty.firstChild);
      else return;

      undo.focus({ preventScroll: true });
      hide = setTimeout(dismiss, SHOW_MS);

      undo.addEventListener('click', function () {
        clearTimeout(hide);
        undo.disabled = true;
        text.textContent = 'Adding ' + wine.title + ' back.';
        fetch((window.theme && theme.routes && theme.routes.cart_add_url ? theme.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: wine.id, quantity: wine.quantity }] })
        }).then(function (response) {
          if (!response.ok) throw new Error(response.status);
          document.addEventListener('theme:cart:change', dismiss, { once: true });
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }).catch(function () {
          text.textContent = 'That didn\'t work. Add ' + wine.title + ' again from its page.';
          undo.hidden = true;
          hide = setTimeout(dismiss, SHOW_MS);
        });
      });
    });
  }

  initCartUndo();

  // Cart: the panel is a dialog only while it is open.
  // aria-modal tells a screen reader to ignore the rest of the page, which
  // is right while the cart holds it and wrong the rest of the time, so it
  // goes on and comes off with the drawer rather than sitting in the markup.
  function initCartDrawerDialog() {
    var panel = document.querySelector('#cart-drawer [data-cart-drawer-inner]');
    if (!panel) return;

    document.addEventListener('theme:cart-drawer:open', function () {
      panel.setAttribute('aria-modal', 'true');
    });

    document.addEventListener('theme:cart-drawer:close', function () {
      panel.removeAttribute('aria-modal');
    });
  }

  initCartDrawerDialog();

  // Cart: the page's scrollbar comes back after the cart has gone.
  //
  // theme.js releases the scroll lock the moment the cart starts to close,
  // so on a computer the page's scrollbar would reappear while the panel is
  // still sliding out and push it sideways by its own width. The theme's
  // unlock can wait: it takes a delay in milliseconds as the event's detail.
  // So the unlock that follows a cart close is held back and sent again with
  // the panel's own slide time (custom.css --cd-slide; 0.01ms under reduced
  // motion, which is sent on at once), read from the panel so the two can't
  // drift apart. Reopening the cart in that time cancels the pending unlock
  // (theme.js clears it when it locks).
  function initCartCloseUnlock() {
    var panel = document.querySelector('#cart-drawer [data-cart-drawer-inner]');
    if (!panel) return;
    var closing = false;

    document.addEventListener('theme:cart-drawer:close', function () {
      closing = true;
    });

    document.addEventListener('theme:scroll:unlock', function (event) {
      if (!closing || event.detail) return;
      closing = false;
      var wait = Math.ceil(parseFloat(getComputedStyle(panel).animationDuration) * 1000);
      if (!(wait > 1)) return;
      event.stopPropagation();
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true, detail: wait }));
    });
  }

  initCartCloseUnlock();

  // Background videos further down a page start loading when they come on
  // screen. video.liquid gives any video-background outside the page's first
  // section its id as data-video-defer instead of data-video-id, so the
  // theme's video-background.js leaves it alone; this hands the id over as
  // it appears and puts the element back in its place, which makes the
  // theme set it up again, now with its id. The poster shows until then.
  function initVideoDefer() {
    var held = document.querySelectorAll('video-background[data-video-defer]');
    if (!held.length) return;

    function release(player) {
      player.setAttribute('data-video-id', player.getAttribute('data-video-defer'));
      player.removeAttribute('data-video-defer');
      player.parentNode.insertBefore(player, player.nextSibling);
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(held, release);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        release(entry.target);
      });
    });
    Array.prototype.forEach.call(held, function (player) { observer.observe(player); });
  }

  initVideoDefer();
  // A section re-rendered in the theme editor has no position, so its video
  // arrives held; this picks it up.
  document.addEventListener('shopify:section:load', initVideoDefer);

  // A background video stays hidden until it is actually playing, then fades
  // up (custom.css section 11). video-background.js shows the player the
  // moment it adds the video, and the video carries Shopify's own poster, a
  // still of its first frame, so otherwise the section's poster would be
  // covered by a different picture until the video moves. is-playing goes on
  // the player once its video plays. A video that never plays (reduced
  // motion, or autoplay blocked) leaves the section's poster up, and pressing
  // play brings it in.
  function initVideoReveal() {
    function reveal(video) {
      var player = video.closest('video-background');
      if (player) player.classList.add('is-playing');
    }

    // playing doesn't bubble, so it is caught on the way down. A paused
    // video is skipped: video-pause.js pauses on the first play under
    // reduced motion, and the playing event can still arrive after that.
    document.addEventListener('playing', function (event) {
      var video = event.target;
      if (!video || video.tagName !== 'VIDEO' || video.paused) return;
      reveal(video);
    }, true);

    // In case a video was already playing before this ran.
    Array.prototype.forEach.call(document.querySelectorAll('video-background video'), function (video) {
      if (!video.paused && video.readyState > 2) reveal(video);
    });
  }

  initVideoReveal();


  // Mobile menu drawer accordion.
  // Child menus expand in place instead of sliding to a new panel.
  // Markup: snippets/nav-item-mobile.liquid. Styles: custom.css section 9.
  function initDrawerAccordion() {
    function panelFor(btn) {
      return document.getElementById(btn.getAttribute('aria-controls'));
    }

    function setState(btn, open) {
      var panel = panelFor(btn);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!panel) return 0;
      if (open) {
        panel.setAttribute('data-open', '');
      } else {
        panel.removeAttribute('data-open');
      }
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-accordion-toggle]');
      if (!btn || !btn.closest('.drawer--header')) return;

      event.preventDefault();

      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var container = btn.parentElement && btn.parentElement.parentElement;

      // Close any sibling open at the same level before opening this one.
      //
      // Their heights are taken before they are told to close, because they
      // collapse over the same 350ms and their space has to come out of the
      // scroll measurements or the list aims at a position that stops
      // existing. Only what sits above this row counts toward its offset; a
      // section below it does not move it.
      // A top level row closes every other top level row, wherever it is. The
      // groups are four Shopify menus but one list to read, so leaving one
      // open in each is four open sections and a drawer you have to scroll
      // twice. Deeper rows still only close their own siblings, or opening a
      // child would shut the section it lives in.
      var isTopLevel = container && container.classList.contains('drawer__main-menu');
      var isFootRow = !!btn.closest('.drawer__bottom');

      var scope = container;
      var siblingSelector = ':scope > .drawer-acc__wrapper > [data-accordion-toggle][aria-expanded="true"]';

      if (isTopLevel) {
        scope = btn.closest('.drawer__menu') || container;
        siblingSelector = '.drawer__main-menu > .drawer-acc__wrapper > [data-accordion-toggle][aria-expanded="true"]';
      } else if (isFootRow) {
        // The hours and the booking options are one pair: opening either
        // closes the other. They sit at different depths, the hours button
        // directly in its row and the booking button inside a wrapper, so the
        // search is by what they are rather than by where they are.
        scope = btn.closest('.drawer__bottom');
        siblingSelector = '[data-accordion-toggle][aria-expanded="true"]';
      }

      var closing = { total: 0, above: 0, panels: [], toggles: [] };
      if (!isOpen && scope) {
        var myTop = btn.parentElement ? btn.parentElement.getBoundingClientRect().top : 0;
        scope
          .querySelectorAll(siblingSelector)
          .forEach(function (sibling) {
            var siblingPanel = panelFor(sibling);
            if (siblingPanel) {
              var h = siblingPanel.getBoundingClientRect().height;
              closing.total += h;
              closing.panels.push(siblingPanel);
              closing.toggles.push(sibling);
              if (sibling.parentElement &&
                  sibling.parentElement.getBoundingClientRect().top < myTop) {
                closing.above += h;
              }
            }
            // Not closed yet: it closes with the new one instead.
          });
      }

      // Before the state changes, so the ceiling can be measured by putting
      // the list into its finished state and back without anything painting.
      var panel = panelFor(btn);

      // The control answers immediately either way. aria-expanded goes on
      // now, so the chevron turns and the label takes its colour the instant
      // it is tapped; only the content waits.
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

      if (isOpen) {
        // Closing: hold the room, collapse, then let the list settle back.
        //
        // The room is reserved, the panel is told to collapse, and the list is
        // sent back, all in the same frame. The reservation is what lets the
        // scroll run while the panel is still shrinking: without it the list
        // gets shorter underneath the scroll and the browser takes the
        // position back in one go.
        holdRoomForClose(btn, panel);
        markMoving(panel);
        setState(btn, false);
        revealPanel(btn, panel, closing, false);
        syncCatch(btn);
        return;
      }

      // The scroll is started and the panels are swapped in the same frame.
      //
      // The scroll is the browser's own smooth scroll, which it runs without
      // the main thread where it can, so it does not compete with the panels'
      // layout animation. Sequencing them would need a handover, and the
      // browser does not say when its scroll has finished, so the handover
      // would run on an estimate: the swap lands mid-scroll and the scroll
      // carries on after it. One movement, not four.
      revealPanel(btn, panel, closing, true);

      closing.toggles.forEach(function (sibling) {
        markMoving(panelFor(sibling));
        setState(sibling, false);
      });
      markMoving(panel);
      setState(btn, true);
      syncCatch(btn);
    });
  }

  // Carries will-change only for as long as the panel is actually moving.
  // Left on, every panel in the drawer holds a layer it does not need.
  function markMoving(panel) {
    if (!panel) return 0;
    panel.classList.add('is-moving');
    if (panel._movingTimer) clearTimeout(panel._movingTimer);
    panel._movingTimer = setTimeout(function () {
      panel.classList.remove('is-moving');
      panel._movingTimer = null;
    }, drawerMotionMs() + 60);
  }

  // Reserves the space a closing panel is about to give up, so the list keeps
  // its height while the panel shrinks and the browser has nothing to clamp.
  // Released by revealPanel once it has done the scroll.
  function holdRoomForClose(btn, panel) {
    if (!panel) return;
    var scroller = btn.closest('.drawer__content__scroll');
    if (!scroller || !scroller.scrollTop) return;
    var inner = panel.querySelector('.drawer-acc__panel__inner');
    var full = inner ? inner.scrollHeight : 0;
    if (!full) return;
    if (drawerClearPad) drawerClearPad();
    scroller.style.paddingBottom = full + 'px';
    drawerClearPad = function () {
      scroller.style.paddingBottom = '';
      drawerClearPad = null;
    };
  }

  // Where the list has to scroll to so a section that has just opened is fully
  // on screen. Pure, so it can be reasoned about without a layout engine.
  //   top     the row's offset inside the scroller
  //   rowH    the row's own height
  //   panelH  the panel's height once open
  //   at      the scroller's current scrollTop
  //   view    the scroller's visible height
  function drawerScrollTarget(top, rowH, panelH, at, view) {
    var bottom = top + rowH + panelH;
    if (rowH + panelH > view) return Math.max(0, top - 8);   // taller than the view: pin the row to the top
    if (bottom > at + view) return Math.max(0, bottom - view + 16);
    if (top < at) return Math.max(0, top - 8);
    return at;                                               // already fully visible
  }

  var drawerClearPad = null;
  var drawerReducedQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  // The last section in the drawer is the one that needs this: opening it
  // pushes its own contents below the fold, and without a scroll you see the
  // heading and a cut off list.
  //
  // The panel's height is the browser's job, through the CSS transition on
  // grid-template-rows. Only the scroll is driven here.
  //
  // Two things have to be corrected for. Writing scrollTop clamps to the
  // scroller's height at that instant, and while the panel is still growing
  // there is nothing to scroll into, so the list is padded by the panel's
  // height for the duration and the padding cleared after. And whatever was
  // open is collapsing at the same time, so its height comes out of the
  // measurements or the scroll aims at a position that stops existing.
  function revealPanel(btn, panel, closing, opening) {
    if (!panel) return;
    var scroller = btn.closest('.drawer__content__scroll');
    if (!scroller) return;

    var inner = panel.querySelector('.drawer-acc__panel__inner');
    var full = inner ? inner.scrollHeight : 0;
    if (!full) return;

    // Closing from the top of the list cannot clamp anything, so there is
    // nothing to animate and nothing to pay for.
    if (!opening && !scroller.scrollTop) return;

    var box = scroller.getBoundingClientRect();
    if (!box.height) return;                 // not laid out; nothing to correct

    var wrap = btn.parentElement;
    var top = wrap.getBoundingClientRect().top - box.top + scroller.scrollTop;
    var view = scroller.clientHeight;
    var at = scroller.scrollTop;

    var closingTotal = (closing && closing.total) || 0;
    var closingAbove = (closing && closing.above) || 0;

    // Cheap first. Most sections open without the list moving at all, and the
    // measurement below costs two synchronous layouts at the exact moment the
    // animation starts. Done for a section that is not going to scroll, it
    // makes opening one while another is open feel rough.
    //
    // Closing never moves you on purpose. It only keeps you inside what is
    // left, which is why the target is where you already are and the clamp
    // below is what does the work.
    // Cheap, and true whatever is collapsing: a list sitting at the top cannot
    // be clamped, because nothing can make zero out of range. So if it is at
    // the top and the row and its panel fit in view, no scroll is possible and
    // none of the work below needs doing.
    //
    // Not gated on nothing collapsing: opening one section while another is
    // open is the ordinary case, not the exception, and that would put the
    // measurement back in the path of every one of them.
    if (!at && top + btn.offsetHeight + full <= view) return;

    // Opening only. The question this answers is whether the row needs
    // bringing into view, and on a close that is the wrong question: the list
    // has not moved, the content under it is about to get shorter, and only
    // the ceiling knows by how much. Run on a close, it would match the
    // position the open had scrolled to and return early, leaving the list
    // sitting where it was.
    if (opening && !closingTotal) {
      var quick = drawerScrollTarget(top, btn.offsetHeight, full, at, view);
      if (quick === at) return;
    }

    var ceiling = measureDrawerCeiling(scroller, panel, closing && closing.panels, opening);

    // Where the list will sit once whatever is collapsing has gone. Anything
    // above that is not a choice: the content is not there any more and the
    // browser would take it back regardless.
    var settledAt = Math.min(at, ceiling);

    // The target is worked out from there, not from where the list happens to
    // be now. Measuring against the current position would ask for a scroll
    // that the settling has already done, so a row that was going to be
    // perfectly visible anyway would get pinned to the top as well: two moves
    // where one is needed, and the second one is the part that reads as
    // sudden.
    var want = opening
      ? drawerScrollTarget(top - closingAbove, btn.offsetHeight, full, settledAt, view)
      : settledAt;

    var to = Math.min(Math.max(0, want), ceiling);
    if (to === at) {
      // Nothing to move, so anything being held on the list's behalf can go.
      if (drawerClearPad) drawerClearPad();
      return;
    }

    // Opening, the room has to exist before the panel grows into it, so any
    // older hold is released and a new one taken. Closing, the room was
    // reserved before the collapse began and has to stay: releasing it here
    // shortens the list while the scroll is still to come, and the browser
    // takes the position back in a single frame. That is the snap.
    if (opening) {
      if (drawerClearPad) drawerClearPad();
      var padFrom = full + closingTotal;
      if (padFrom) scroller.style.paddingBottom = padFrom + 'px';
      drawerClearPad = function () {
        scroller.style.paddingBottom = '';
        drawerClearPad = null;
      };
    }

    var from = at;
    var delta = to - from;
    var reduced = !!(drawerReducedQuery && drawerReducedQuery.matches);

    // The scroll is handed to the browser rather than driven a frame at a
    // time.
    //
    // Writing scrollTop sixty times a second while the panel's grid row is
    // animating means the scroller is being told to move inside a box whose
    // layout is being invalidated underneath it, and the two do not cooperate:
    // on the longest panel, the only one that scrolls, it comes out as a
    // handful of visible stutters rather than a move.
    //
    // Native smooth scrolling is the browser's own implementation and does not
    // compete with the transition for the main thread. The trade is the curve:
    // its easing is not the site's. On a viewport move that is a fair trade,
    // and it is the one thing here the reader is not looking at.
    //
    // The padding above is what makes it work. scrollTo clamps to the height
    // at the moment it is called, and the panel has not grown yet, so without
    // the room reserved first there would be nowhere to go.
    if (!delta) {
      drawerClearPad();
      return;
    }

    if (reduced || typeof scroller.scrollTo !== 'function') {
      scroller.scrollTop = to;
    } else {
      scroller.scrollTo({ top: to, behavior: 'smooth' });
    }

    // Held until the panel has finished, then released. Clearing it earlier
    // would shorten the list while the scroll was still running and the
    // browser would pull it back.
    // The browser does not say when its smooth scroll has finished, so the
    // padding is held for long enough to cover both it and the panel. Only
    // the release depends on this, and releasing a little late costs nothing:
    // the padding is invisible, it only reserves room at the bottom of a list
    // that is already scrolled.
    var scrollMs = Math.min(420, Math.max(220, Math.abs(delta) * 1.1));
    setTimeout(function () {
      if (drawerClearPad) drawerClearPad();
    }, scrollMs + drawerMotionMs());
  }

  // The ceiling is measured, not predicted.
  //
  // Working it out from scrollHeight, the panel's height and what is
  // collapsing comes out a little generous, because those measure from
  // different edges and the difference shifts with the padding on the list.
  // The scroll then eases to a position that does not exist once the padding
  // comes off, and the browser pulls it back, which is the snap.
  //
  // So put the list into the state it is about to finish in for one frame,
  // with transitions off so nothing animates and no padding so nothing is
  // reserved, read what the browser says the maximum scroll is, and put it
  // all back. Nothing paints, because it happens inside one frame.
  function measureDrawerCeiling(scroller, panel, closingPanels, endsOpen) {
    var saved = [];
    function freeze(el, wantOpen) {
      saved.push([el, el.style.transition, el.hasAttribute('data-open')]);
      el.style.transition = 'none';
      if (wantOpen) el.setAttribute('data-open', '');
      else el.removeAttribute('data-open');
    }

    // The finished list is shorter than the one on screen, so putting it into
    // that state makes the browser clamp scrollTop to fit. Restoring the
    // height afterwards does not restore the position, because nothing asks
    // it to, and the scroll has then already arrived: the move that was meant
    // to be animated happened inside a measurement. Held and put back.
    var heldScroll = scroller.scrollTop;

    freeze(panel, endsOpen);
    if (closingPanels) closingPanels.forEach(function (p) { freeze(p, false); });

    var pad = scroller.style.paddingBottom;
    scroller.style.paddingBottom = '';
    var ceiling = Math.max(0, scroller.scrollHeight - scroller.clientHeight);

    saved.forEach(function (r) {
      if (r[2]) r[0].setAttribute('data-open', '');
      else r[0].removeAttribute('data-open');
    });
    scroller.style.paddingBottom = pad;
    void scroller.offsetHeight;                 // commit, so the height is back
    scroller.scrollTop = heldScroll;            // then the position, into it
    saved.forEach(function (r) { r[0].style.transition = r[1]; });

    return ceiling;
  }

  // Read from --drawer-acc-motion so the scroll and the panel cannot drift
  // apart when one of them is retimed.
  function drawerMotionMs() {
    var drawer = document.querySelector('.drawer--header');
    if (!drawer) return 350;
    var raw = getComputedStyle(drawer).getPropertyValue('--drawer-acc-motion').trim();
    var n = parseFloat(raw);
    if (!n) return 350;
    return raw.indexOf('ms') > -1 ? n : n * 1000;
  }


  // The catcher covers the menu list whenever one of the rows beneath it has
  // a panel open. A tap up there closes the panel and reaches nothing else,
  // which is the whole of its job: one tap, one outcome.
  //
  // It comes down on that same tap rather than waiting for the panel to
  // finish leaving. The thing worth preventing is a single tap both closing a
  // panel and opening a menu row; once that tap has been spent the list is
  // free again, and holding it through the animation only makes the drawer
  // feel stuck.
  function footPanelOpen() {
    var drawer = document.querySelector('.drawer--header');
    if (!drawer) return null;
    return drawer.querySelector('.drawer__bottom [data-accordion-toggle][aria-expanded="true"]');
  }

  function syncCatch(btn) {
    var drawer = document.querySelector('.drawer--header');
    if (!drawer) return;
    var catcher = drawer.querySelector('[data-drawer-catch]');
    if (!catcher) return;
    if (!btn || !btn.closest('.drawer__bottom')) return;   // menu rows do not raise it

    var open = footPanelOpen();
    catcher.hidden = !open;
    if (open) catcher.setAttribute('aria-label', catchLabel(open));
  }

  function catchLabel(toggle) {
    var label = toggle.querySelector('[data-hours-summary]') ? 'opening hours' : 'booking options';
    return 'Close ' + label;
  }

  function initDrawerCatch() {
    var drawer = document.querySelector('.drawer--header');
    if (!drawer) return;
    var catcher = drawer.querySelector('[data-drawer-catch]');
    if (!catcher) return;

    catcher.addEventListener('click', function () {
      var open = footPanelOpen();
      if (open) open.click();
    });
  }

  initDrawerAccordion();
  initDrawerCatch();


  // Desktop navigation.
  //
  // Four things theme.js either cannot do or does not do correctly. It owns
  // <hover-disclosure> and says in its header not to be edited, so all of this
  // hangs off the class and attributes it already sets.
  function initDesktopNav() {
    var menu = document.querySelector('.header__menu');
    if (!menu) return;
    var items = Array.prototype.slice.call(menu.querySelectorAll('hover-disclosure'));
    if (!items.length) return;

    var hoverQuery = window.matchMedia ? window.matchMedia('(hover: hover)') : null;

    // Below 1100 the bar's menu is hidden but still laid out (custom.css,
    // the switch to the menu button: the same number, change both together),
    // and its overflow clips the panels, so placing them there is a forced
    // layout for nothing on every phone page. Placing waits for the bar: a
    // resize across 1100 places every panel.
    var barQuery = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : null;

    function isOpen(item) {
      return item.classList.contains('is-visible');
    }

    // 1. Keep the panel inside the gutter.
    //
    // A panel opens flush with its own item, so for the items at the right
    // hand end it runs past the gutter and, for the shortest labels, past the
    // window. .header__menu is justified to the end of its row, so its own
    // right edge sits on the gutter and is the line to measure against. No
    // gutter value has to be read here, so the 16 / 30 / 100 steps are
    // followed without being repeated.
    //
    // The panel is pulled back by exactly the amount it overhangs, which lands
    // its right edge on the gutter. The item's right edge is the wrong line:
    // for anything but the last item that is not the gutter, and for the
    // last item it leaves the panel sitting in the gutter rather than
    // against it.
    //
    // The panel rests at visibility:hidden, which still lays out, so it can be
    // measured before it is seen. So closed panels are placed too: at load,
    // once the fonts are in, and after a resize. Resting where theme.css puts
    // them, flush with their items, a closed panel can reach past the right
    // edge of the window, and a touch screen widens the page to take it in.
    // An open panel is left alone at load, since moving it would shift it
    // under the pointer (a carried panel); it is placed as it closes.
    function place(item) {
      if (barQuery && !barQuery.matches) return 0;
      var panel = item.querySelector('.header__dropdown');
      if (!panel) return 0;
      panel.style.removeProperty('--nav-panel-pull');
      var edge = menu.getBoundingClientRect().right;
      if (!edge) return;                       // not laid out; nothing to correct
      var over = panel.getBoundingClientRect().right - edge;
      if (over > 0) panel.style.setProperty('--nav-panel-pull', Math.ceil(over) + 'px');
    }

    function placeClosed() {
      items.forEach(function (item) { if (!isOpen(item)) place(item); });
    }

    // 2. Put the state on the element that takes focus.
    //
    // theme.js writes aria-expanded on the wrapper. A screen reader announces
    // the link inside it, so that is where the state has to be as well.
    function mirror(item) {
      var link = item.querySelector('[data-top-link]');
      if (link) link.setAttribute('aria-expanded', isOpen(item) ? 'true' : 'false');
    }

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        place(record.target);
        mirror(record.target);
      });
    });

    items.forEach(function (item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
      mirror(item);

      // 3. First tap opens, second follows.
      //
      // Broadcast intends exactly this: handleTablets() calls preventDefault
      // on touchstart. That listener is registered {passive: true}, where
      // preventDefault is ignored by every browser, so on a touch screen the
      // first tap opens the panel and navigates away from under it at the
      // same time. Doing it on click instead is where it works.
      var link = item.querySelector('[data-top-link]');
      if (!link) return;
      link.addEventListener('click', function (event) {
        var noHover = hoverQuery ? !hoverQuery.matches : false;
        if (noHover && !isOpen(item)) event.preventDefault();
      });
    });

    placeClosed();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeClosed);

    // The gutter changes at 750 and 990 and the menu scales with the window,
    // so every panel, open or closed, is measured again after a resize.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        items.forEach(function (item) { place(item); });
      }, 120);
    }, { passive: true });

    // 4. A panel open under the mouse stays open into the next page.
    //
    // Leaving the page with a panel open under the pointer (a link in it
    // clicked, say), this notes which panel, and where custom.css had
    // pulled it back to. Its links don't keep their hover colour: gold
    // comes back when the new page can take a click. layout/theme.liquid
    // opens the same panel on the next page before it is first drawn, so
    // the crossfade carries it across still, and keeps it open until the
    // pointer shows it has left.
    // Mouse only: a panel opened by keyboard or a tap isn't carried.
    //
    // A page built ahead by a prerender (head.liquid) can be opened before
    // this page's pagehide runs, so the note is made as the link is
    // followed, and pagehide makes it only if that didn't happen.
    // Made twice, the second could land after the next page had read and
    // cleared the first, and open a panel on a later page.
    var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
    var carryNoted = false;
    if (window.navigation) {
      window.navigation.addEventListener('navigate', function (event) {
        if (event.destination.sameDocument || event.hashChange || event.downloadRequest !== null) return;
        noteCarry();
        carryNoted = true;
      });
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) carryNoted = false;
    });
    window.addEventListener('pagehide', function () {
      if (!carryNoted) noteCarry();
    });
    function noteCarry() {
      try {
        sessionStorage.removeItem('navCarry');
        if (!finePointer || !finePointer.matches) return;
        var open = items.filter(function (item) {
          return isOpen(item) && item.matches(':hover');
        })[0];
        if (!open) return;
        var panel = open.querySelector('.header__dropdown');
        sessionStorage.setItem('navCarry', JSON.stringify({
          key: open.getAttribute('aria-controls'),
          pull: panel ? panel.style.getPropertyValue('--nav-panel-pull') : '',
          at: Date.now()
        }));
      } catch (error) {}
    }
  }

  initDesktopNav();



  /* ----------------------------------------------------------------------
     Opening hours
     ---------------------------------------------------------------------- */

  /* The hours engine.
   *
   * One text field per venue carries its whole year. A date line opens a block,
   * the block covering today is the one that applies, and a block with no date
   * line applies all year.
   *
   * Two things fall out of that. A venue whose blocks cover none of today is not
   * listed at all, which is how the food truck appears for the season and then
   * stops existing. And a day can hold more than one range, which is how the
   * restaurant holds lunch and dinner without being two entries.
   *
   * The day and the time are read in Australia/Melbourne. Somebody checking from
   * Perth is asking what time it is at the winery. Intl carries the daylight
   * saving rules, so nothing here changes in October or April.
   */

  var HoursEngine = (function () {

    var DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    var MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
                  'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    var DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday',
                     'Friday', 'Saturday', 'Sunday'];

    /* The moment, as the winery sees it. Worked out from Victoria's daylight
     * saving rule rather than the browser's time zone data: building a
     * formatter for a named zone costs about 85ms on a slowed phone, on
     * every page, while the page loads. Daylight saving (UTC+11) runs from
     * 2am on the first Sunday in October to 3am on the first Sunday in
     * April, both 16:00 UTC the Saturday before; UTC+10 otherwise. Change
     * this if Victoria changes its dates. */
    function firstSunday(year, month) {
      return 1 + (7 - new Date(Date.UTC(year, month, 1)).getUTCDay()) % 7;
    }

    function localNow(now) {
      var t = (now || new Date()).getTime();
      var year = new Date(t).getUTCFullYear();
      var dstStarts = Date.UTC(year, 9, firstSunday(year, 9) - 1, 16);
      var dstEnds = Date.UTC(year, 3, firstSunday(year, 3) - 1, 16);
      var hours = (t >= dstStarts || t < dstEnds) ? 11 : 10;
      var local = new Date(t + hours * 3600000);

      return {
        year: local.getUTCFullYear(),
        month: local.getUTCMonth() + 1,
        day: local.getUTCDate(),
        weekday: (local.getUTCDay() + 6) % 7,
        minutes: local.getUTCHours() * 60 + local.getUTCMinutes()
      };
    }

    /* "1 Nov - 30 Apr" and "27 Dec - 26 Jan" both parse, and so does a name
     * after the dates, "27 Dec - 10 Jan Summer holidays", which only the
     * Hours page shows (venue-hours.liquid prints it). Returns month-day
     * numbers, which is what makes a range able to cross the new year. */
    function parseDateLine(line) {
      var m = String(line).toLowerCase().trim()
        .match(/^(\d{1,2})\s+([a-z]{3})[a-z]*\s*[-\u2013]\s*(\d{1,2})\s+([a-z]{3})[a-z]*(?:\s+.*)?$/);
      if (!m) return null;
      var fromMonth = MONTHS.indexOf(m[2]);
      var toMonth = MONTHS.indexOf(m[4]);
      if (fromMonth < 0 || toMonth < 0) return null;
      return {
        from: (fromMonth + 1) * 100 + parseInt(m[1], 10),
        to: (toMonth + 1) * 100 + parseInt(m[3], 10)
      };
    }

    /* "12:00-15:00, 18:00-21:00" gives two ranges, from a day line or a
     * Special hours entry. Anything unreadable is left out, so a day with
     * nothing readable is closed: wrong in the direction that does not send
     * somebody on a drive. */
    function parseRanges(text) {
      var ranges = [];
      String(text || '').split(',').forEach(function (part) {
        var r = part.trim().match(/^(\d{1,2}):(\d{2})\s*[-\u2013]\s*(\d{1,2}):(\d{2})$/);
        if (!r) return;
        ranges.push({
          open: parseInt(r[1], 10) * 60 + parseInt(r[2], 10),
          close: parseInt(r[3], 10) * 60 + parseInt(r[4], 10)
        });
      });
      return ranges;
    }

    /* "Thu 12:00-15:00, 18:00-21:00" gives two ranges on Thursday. */
    function parseDayLine(line) {
      var clean = String(line).toLowerCase().trim();
      var m = clean.match(/^(mon|tue|wed|thu|fri|sat|sun)[a-z]*\s+(.*)$/);
      if (!m) return null;
      return { day: DAYS.indexOf(m[1]), ranges: parseRanges(m[2]) };
    }

    /* The whole field: a list of blocks, each with an optional date range and a
     * week of seven days. */
    function parseSchedule(text) {
      var blocks = [];
      var current = null;

      function open(range) {
        current = { range: range, week: [null, null, null, null, null, null, null] };
        blocks.push(current);
      }

      String(text || '').split('\n').forEach(function (line) {
        // A blank line ends the block. Without this an undated block written
        // after a dated one has nowhere to go: its days land in the dated block
        // and overwrite it, so a venue meant to have a fallback for the rest of
        // the year quietly has none and vanishes outside its dates.
        if (!line.trim()) { current = null; return; }

        var range = parseDateLine(line);
        if (range) { open(range); return; }

        var day = parseDayLine(line);
        if (!day) return;
        if (!current) open(null);              // no date line above it: all year
        current.week[day.day] = day.ranges.length ? day.ranges : null;
      });

      return blocks;
    }

    function coversDate(range, date) {
      if (!range) return true;                 // no date line: all year
      var today = date.month * 100 + date.day;
      if (range.from <= range.to) return today >= range.from && today <= range.to;
      return today >= range.from || today <= range.to;   // crosses the new year
    }

    /* The block that applies today, or null if none does.
     *
     * A dated block beats an undated one, so a venue can have a normal year with
     * a season laid over part of it. Where two dated blocks both cover today,
     * the last one wins: put the rule first and the exception after it, which is
     * how anybody would read the field top to bottom anyway.
     *
     * That is what lets the food truck run weekends from November and then every
     * day from 27 December, without the first range having to be cut in two
     * around the second. */
    function blockFor(blocks, date) {
      var fallback = null;
      var match = null;
      for (var i = 0; i < blocks.length; i++) {
        if (!blocks[i].range) { if (!fallback) fallback = blocks[i]; continue; }
        if (coversDate(blocks[i].range, date)) match = blocks[i];
      }
      return match || fallback;
    }

    /* A Special hours entry: a venue's hours on the dates it covers, in
     * place of the season's, such as dinner on a long weekend's Friday.
     * First day and Last day are date fields, so there is no time zone to
     * turn, and a blank Last day is the one day. Where two cover a date the
     * later one wins, as with seasons. Closures still come out of them. */
    function specialFor(venue, date) {
      var today = date.year * 10000 + date.month * 100 + date.day;
      var match = null;
      ((venue && venue.specials) || []).forEach(function (s) {
        var from = dayNumber(s.firstDay);
        var to = dayNumber(s.lastDay) || from;
        if (from && today >= from && today <= to) match = s;
      });
      return match;
    }

    /* A venue's hours on one date, before closures: a Special hours entry
     * covering it, otherwise the season in force. undefined when neither
     * applies (out of season, so not listed), null when it is shut that day. */
    function hoursOn(venue, blocks, date) {
      var special = specialFor(venue, date);
      if (special) {
        var ranges = parseRanges(special.hours);
        return ranges.length ? ranges : null;
      }
      var block = blockFor(blocks, date);
      if (!block) return undefined;
      return block.week[date.weekday];
    }

    function dayNumber(iso) {
      var m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
      return m ? parseInt(m[1], 10) * 10000 + parseInt(m[2], 10) * 100 + parseInt(m[3], 10) : 0;
    }

    /* A closure is a span between two moments.
     *
     * First day and Last day are date-and-time fields, so both the days and
     * the hours come from Shopify rather than being typed, and nothing in a
     * closure can be mistyped.
     *
     * Last day blank means the end of the day it starts on, so a whole-day
     * closure is one field.
     */
    function readMoment(value, endOfDay) {
      var text = String(value || '');
      // A time with a zone is an instant, and Shopify prints date-and-time
      // fields in UTC: midnight on 26 December in Melbourne arrives as
      // 2026-12-25T13:00:00Z. Read as written it would be 1pm the day
      // before, so it is turned into the winery's day and minute the way
      // localNow turns the clock.
      if (/T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})$/.test(text)) {
        var instant = new Date(text);
        if (!isNaN(instant.getTime())) {
          var local = localNow(instant);
          return { day: local.year * 10000 + local.month * 100 + local.day, minutes: local.minutes };
        }
      }
      var m = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
      if (!m) return null;
      var day = parseInt(m[1], 10) * 10000 + parseInt(m[2], 10) * 100 + parseInt(m[3], 10);
      var minutes = m[4] !== undefined
        ? parseInt(m[4], 10) * 60 + parseInt(m[5], 10)
        : (endOfDay ? 1439 : 0);
      return { day: day, minutes: minutes };
    }

    /* Applies to is a list of venues: one closure can shut the Restaurant and
     * the Terrace together. A single name still reads, as one venue. Names are
     * matched lower case, and an empty list with nothing chosen means the
     * whole property. */
    function closureVenues(value) {
      var list = Array.isArray(value) ? value : [value];
      return list.map(function (v) { return String(v || '').trim().toLowerCase(); })
                 .filter(function (v) { return v; });
    }

    function readClosure(c) {
      var from = readMoment(c.startsAt, false);
      if (!from) return null;
      var to = readMoment(c.endsAt, true) || { day: from.day, minutes: 1439 };
      // 12am ends the day before. Shopify's time picker stops at 11.30pm and
      // Last day can't be emptied once it holds a date, so a closure through
      // the whole of a day is entered as ending at 12am the next day. Read as
      // written it reaches into that day, and the Hours page prints it as
      // running "to 12am" on the next date.
      if (to.minutes === 0 && to.day > from.day) {
        var eve = new Date(Date.UTC(Math.floor(to.day / 10000), Math.floor(to.day / 100) % 100 - 1, to.day % 100 - 1));
        to = { day: eve.getUTCFullYear() * 10000 + (eve.getUTCMonth() + 1) * 100 + eve.getUTCDate(), minutes: 1439 };
      }
      return {
        from: from,
        to: to,
        scoped: !!c.scoped,
        appliesTo: closureVenues(c.appliesTo),
        // Blank when none was typed: each place that shows a closure says
        // Closed in its own words, and a part-day closure with no reason
        // keeps the venue's own note rather than a bare Closed.
        reason: (c.reason || '').trim(),
        yearly: c.yearly === true
      };
    }

    /* A closure ticked Repeats every year (Christmas Day, Boxing Day) is
     * copied into last year, this year and next year, so the day's check,
     * the week ahead and the Hours page's six weeks all find it whatever
     * year its dates were entered in. Three years rather than one: the week
     * ahead and the six weeks reach into next year from late December, and
     * a span across New Year starts in the year before. A span keeps its
     * length in years, so 31 December to 1 January stays one night. Every
     * other closure passes through as it is. */
    function expandYearly(closures, date) {
      var out = [];
      closures.forEach(function (c) {
        if (!c.yearly) {
          out.push(c);
          return;
        }
        var span = Math.floor(c.to.day / 10000) - Math.floor(c.from.day / 10000);
        for (var y = date.year - 1; y <= date.year + 1; y++) {
          out.push({
            from: { day: y * 10000 + c.from.day % 10000, minutes: c.from.minutes },
            to: { day: (y + span) * 10000 + c.to.day % 10000, minutes: c.to.minutes },
            scoped: c.scoped,
            appliesTo: c.appliesTo,
            reason: c.reason,
            yearly: true
          });
        }
      });
      return out;
    }

    /* The part of one date that a closure covers, as minutes from midnight, or
     * null if it does not reach that date at all. A span that starts before the
     * day and ends after it gives the whole day. */
    function windowOn(closure, date) {
      var today = date.year * 10000 + date.month * 100 + date.day;
      if (today < closure.from.day || today > closure.to.day) return null;
      return {
        open: today === closure.from.day ? closure.from.minutes : 0,
        close: today === closure.to.day ? closure.to.minutes : 1439
      };
    }

    /* The closures in force today for one venue: the ones with no venue named,
     * which close the property, plus the ones naming this one. */
    function closuresFor(venueName, date, closures) {
      var name = String(venueName || '').trim().toLowerCase();
      return closures.filter(function (c) {
        if (!c || !windowOn(c, date)) return false;
        if (c.appliesTo.length) return c.appliesTo.indexOf(name) !== -1;
        // A venue was chosen but its name did not come through. Close nothing
        // rather than close everything: being wrong about one venue is a
        // mistake, shutting the property by accident is a different order of
        // one.
        if (c.scoped) return false;
        return true;                           // nothing chosen: the property
      });
    }

    /* Takes a closed window out of a day's opening ranges. A range can be
     * shortened at either end, split in two, or removed entirely. Returns what
     * is left, which is empty when the closure covers the whole day. */
    function subtractWindow(ranges, window) {
      var out = [];
      ranges.forEach(function (r) {
        if (window.close <= r.open || window.open >= r.close) { out.push(r); return; }
        if (window.open > r.open) out.push({ open: r.open, close: window.open });
        if (window.close < r.close) out.push({ open: window.close, close: r.close });
      });
      return out;
    }

    function timeLabel(minutes) {
      var h = Math.floor(minutes / 60), m = minutes % 60;
      var suffix = h < 12 ? 'am' : 'pm';
      var hour = h % 12 || 12;
      return m ? hour + '.' + String(m).padStart(2, '0') + suffix : hour + suffix;
    }

    /* What one venue is doing today. Returns null when the venue should not be
     * listed at all, which is a different thing from being closed. */
    function venueToday(venue, date, closures) {
      var blocks = parseSchedule(venue.hours);
      var hours = hoursOn(venue, blocks, date);
      if (hours === undefined) return null;    // out of season: not listed

      var all = closuresFor(venue.venue, date, closures);

      // A closure covering the whole of this date shuts the venue outright,
      // whatever the hours say.
      for (var i = 0; i < all.length; i++) {
        var w = windowOn(all[i], date);
        if (w.open === 0 && w.close >= 1439) {
          return { venue: venue.venue, order: venue.order, shut: true,
                   lines: [all[i].reason || 'Closed today'], note: nextOpenNote(blocks, date, venue, closures) };
        }
      }

      var ranges = hours;
      if (!ranges) {
        return { venue: venue.venue, order: venue.order, shut: true,
                 lines: ['Closed today'], note: nextOpenNote(blocks, date, venue, closures) };
      }

      // The timed ones come out of the day's hours. What is left is what is open,
      // and if nothing is left the venue is shut for the reason given.
      // Compared by content, not by count. Taking 10.30 to 2 out of an 11 to 5
      // day shortens the range rather than removing it, so the count is the same
      // either way, and a closure that plainly did something would look like
      // it had done nothing.
      var reasons = [], notes = [];
      all.forEach(function (c) {
        var was = ranges, before = JSON.stringify(ranges), w = windowOn(c, date);
        ranges = subtractWindow(ranges, w);
        if (JSON.stringify(ranges) !== before && c.reason) {
          reasons.push(c.reason);
          // Its line shows until the closure is over. After that the venue's
          // own line (its last call or Note) is what a guest needs, and the
          // Hours page drops the closure at the same moment. Another day on
          // the stepper starts at midnight, so its closures all show.
          if (w.close > date.minutes) notes.push(closedNote(c.reason, w, was, ranges));
        }
      });

      if (!ranges.length) {
        return { venue: venue.venue, order: venue.order, shut: true,
                 lines: [reasons[0] || 'Closed today'], note: nextOpenNote(blocks, date, venue, closures) };
      }

      var openNow = false, closesAt = 0, opensNext = 0;
      ranges.forEach(function (r) {
        if (date.minutes >= r.open && date.minutes < r.close) {
          openNow = true; closesAt = r.close;
        }
        if (!opensNext && r.open > date.minutes) opensNext = r.open;
      });

      return {
        venue: venue.venue,
        order: venue.order,
        shut: false,
        open: openNow,
        closesAt: closesAt,
        opensAt: opensNext,
        lines: ranges.map(function (r) {
          return timeLabel(r.open) + ' \u2013 ' + timeLabel(r.close);
        }),
        note: notes.length ? notes[0] : lastCallNote(venue, ranges)
      };
    }

    /* The line under the hours a part-day closure leaves: its reason and when
     * it's closed, "until 1pm" when it takes the start of the day, "from 3pm"
     * the end, "from 12pm to 2pm" a gap. Worked out here, so a Reason is
     * written without times and reads right on the Hours page, which prints
     * the closure's own time above it. A reason that names a time itself is
     * left as typed rather than given a second one. */
    function closedNote(reason, w, was, left) {
      if (!left.length || /\d\s*[ap]m\b|\d[:.]\d\d/i.test(reason)) return reason;
      var text = reason.replace(/\.$/, '');
      if (w.open <= was[0].open) return text + ' until ' + timeLabel(left[0].open);
      if (w.close >= was[was.length - 1].close) return text + ' from ' + timeLabel(left[left.length - 1].close);
      return text + ' from ' + timeLabel(w.open) + ' to ' + timeLabel(w.close);
    }

    /* "Kitchen closes 3pm" on a lunch day, "Kitchen closes 8pm" on a day that
     * runs into the evening; "Last tasting 4.30pm" at the cellar door. The
     * venue's Last call label with one of its two times: the later one when
     * the day's hours run past 6pm, the dinner hour the sittings are read by
     * (a range closing after 6pm reaches dinner), the earlier otherwise. Two
     * typed times rather than minutes before close, because the restaurant's
     * kitchen shuts a different gap before lunch's close and dinner's.
     *
     * Falls back to the venue's own note when the label or the day's time is
     * blank or unreadable, and when the time isn't before the day's close (a
     * closure that ends the day early), so it never names a time the venue
     * isn't open for. */
    function lastCallNote(venue, ranges) {
      if (!venue.lastCallLabel || !ranges.length) return venue.note || '';
      var close = ranges[ranges.length - 1].close;
      var time = readClock(close > 1080 ? venue.lastCallLate : venue.lastCallEarly);
      if (time === null || time >= close || time <= ranges[0].open) return venue.note || '';
      return String(venue.lastCallLabel).trim() + ' ' + timeLabel(time);
    }

    /* "15:00", "3:00" or "15.00" as minutes after midnight; null when blank
     * or unreadable. */
    function readClock(text) {
      var m = /^\s*(\d{1,2})[:.](\d{2})\s*$/.exec(text || '');
      if (!m || +m[1] > 23 || +m[2] > 59) return null;
      return +m[1] * 60 + +m[2];
    }

    /* The calendar date n days on, in the same shape as localNow. Worked in
     * UTC so a daylight saving change cannot shift it by a day. */
    function addDays(date, n) {
      var t = new Date(Date.UTC(date.year, date.month - 1, date.day + n));
      return {
        year: t.getUTCFullYear(),
        month: t.getUTCMonth() + 1,
        day: t.getUTCDate(),
        weekday: (date.weekday + n) % 7,
        minutes: 0
      };
    }

    /* Walks forward through the coming week rather than being typed, so it
     * cannot go stale. Each day is read from the hours on that date (a
     * Special hours entry, else the block in force), with that date's
     * closures taken out. Reading every block instead would let a winter
     * Wednesday borrow Thursday from the summer block, and ignoring closures
     * would let the first day of a two-day closure promise tomorrow. */
    function nextOpenNote(blocks, date, venue, closures) {
      for (var step = 1; step <= 7; step++) {
        var day = addDays(date, step);
        var ranges = hoursOn(venue, blocks, day);
        if (!ranges || !ranges.length) continue;

        var shut = closuresFor(venue.venue, day, closures || []);
        for (var c = 0; c < shut.length; c++) {
          ranges = subtractWindow(ranges, windowOn(shut[c], day));
        }
        if (!ranges.length) continue;

        var when = step === 1 ? 'tomorrow' : DAY_NAMES[day.weekday];
        return 'Open ' + when + ' from ' + timeLabel(ranges[0].open);
      }
      return '';
    }

    function today(data, now) {
      if (!data || !data.venues) return { date: null, venues: [], summary: '' };
      var date = localNow(now);
      var closures = expandYearly((data.closures || []).map(readClosure).filter(Boolean), date);

      var rows = data.venues
        .slice()
        .sort(function (a, b) { return (a.order || 0) - (b.order || 0); })
        .map(function (v) { return venueToday(v, date, closures); })
        .filter(Boolean);

      return { date: date, venues: rows, openNow: anyOpen(rows) };
    }

    /* Whether anything is open right now. The line itself reads Opening hours
     * whatever the answer; this only decides the dot beside it. */
    function anyOpen(rows) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].open) return true;
      }
      return false;
    }

    return {
      localNow: localNow, parseDateLine: parseDateLine, parseDayLine: parseDayLine,
      parseRanges: parseRanges, specialFor: specialFor, hoursOn: hoursOn, dayNumber: dayNumber,
      parseSchedule: parseSchedule, coversDate: coversDate, blockFor: blockFor,
      readClosure: readClosure, expandYearly: expandYearly, readMoment: readMoment, windowOn: windowOn,
      closuresFor: closuresFor, subtractWindow: subtractWindow, timeLabel: timeLabel,
      venueToday: venueToday, nextOpenNote: nextOpenNote, lastCallNote: lastCallNote,
      anyOpen: anyOpen, today: today, addDays: addDays
    };
  })();

  // Draws the board into every panel on the page, and the one line into every
  // summary. There are two of each: the toolbar's and the drawer's.
  function initHours() {
    var source = document.querySelector('[data-hours-data]');
    if (!source) return;                       // no metaobjects yet

    var data;
    try {
      data = JSON.parse(source.textContent);
    } catch (e) {
      return;                                  // malformed rather than absent
    }

    var state = HoursEngine.today(data);
    if (!state.venues.length) return;

    var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // The stepper reaches two weeks on: far enough to plan a visit the
    // weekend after next, near enough that the way back to today is a tap on
    // the day. Further out is what the all hours link below is for. Each day
    // is worked out as it's shown, from the schedule already in the page, so
    // the reach costs nothing on load.
    var HOURS_AHEAD = 13;

    // Every day after today carries its date, tomorrow too: "Tomorrow ·
    // Wednesday" is the longest label there could be.
    function dayLabel(date, offset) {
      if (offset === 0) return 'Today \u00b7 ' + days[date.weekday];
      return days[date.weekday] + ' \u00b7 ' + date.day + ' ' + months[date.month - 1];
    }

    // The same, with the weekday's letters after its first three in a span:
    // below 360 the drawer hides them (custom.css), as "Wednesday · 21 Oct"
    // runs under the arrows on a 320px phone and "Wed · 21 Oct" holds the
    // line. Every weekday's short form is its first three letters.
    function dayLabelMarkup(date, offset) {
      if (offset === 0) return escapeHtml(dayLabel(date, offset));
      var name = days[date.weekday];
      return name.slice(0, 3) + '<span class="hours-panel__day-rest">' + name.slice(3) + '</span>' +
        ' \u00b7 ' + date.day + ' ' + months[date.month - 1];
    }

    // Another day's board, from the engine's own pieces, as today() builds
    // today's. The date comes from addDays rather than a clock moved on by
    // whole days, which a daylight saving change would push into the wrong day
    // near midnight. Its minutes are 0, so nothing on it reads as open now:
    // the toolbar's dot stays about this moment.
    //
    // The engine's words are written for today, so two are rewritten for the
    // day shown: "Closed today" on a Saturday is wrong, and "Open tomorrow"
    // under a Saturday means Sunday, which only the day's name makes clear.
    var stepClosures = null;
    function venuesOn(offset) {
      if (!offset) return state.venues;
      var date = HoursEngine.addDays(state.date, offset);
      if (!stepClosures) {
        stepClosures = HoursEngine.expandYearly((data.closures || [])
          .map(HoursEngine.readClosure)
          .filter(Boolean), state.date);
      }
      var after = days[(date.weekday + 1) % 7];
      return data.venues
        .slice()
        .sort(function (a, b) { return (a.order || 0) - (b.order || 0); })
        .map(function (v) { return HoursEngine.venueToday(v, date, stepClosures); })
        .filter(Boolean)
        .map(function (row) {
          row.lines = row.lines.map(function (l) { return l === 'Closed today' ? 'Closed' : l; });
          if (row.note && row.note.indexOf('Open tomorrow ') === 0) {
            row.note = 'Open ' + after + row.note.slice('Open tomorrow'.length);
          }
          return row;
        });
    }

    // The note is its own dd rather than living inside the times.
    //
    // Two descriptions under one term is valid, and it is what lets the layout
    // put the venue and its times on one line with the note spanning beneath
    // them. Inside the times it could only ever sit in their column, and every
    // note would wrap on a phone.
    //
    // In the popout a venue with a Booking link has its name as the link,
    // with Book › revealed beside it on hover or focus (custom.css). The
    // drawer keeps plain names: a phone has no hover to show the cue, and the
    // drawer has its own booking button. A link to another site opens in a
    // new tab, as snippets/link-target.liquid decides for the theme's links.
    var bookingUrls = {};
    (data.venues || []).forEach(function (v) {
      if (v.venue && v.bookingUrl) bookingUrls[v.venue] = String(v.bookingUrl);
    });

    function bookingTarget(url) {
      var host = (url.match(/^[a-z][a-z0-9+.-]*:\/\/([^\/?#]+)/i) || [])[1];
      if (!host) return '';
      var own = location.host.toLowerCase().replace(/^www\./, '');
      if (host.toLowerCase().replace(/^www\./, '') === own) return '';
      return ' target="_blank" rel="noopener"';
    }

    function venueMarkup(name, bookable) {
      var url = bookable && bookingUrls[name];
      if (!url) return escapeHtml(name);
      var target = bookingTarget(url);
      return '<a class="hours-panel__venue" href="' + escapeHtml(url) + '"' + target + '>' +
               escapeHtml(name) +
               '<span class="hours-panel__book" aria-hidden="true">Book <span>&#8250;</span></span>' +
               '<span class="visually-hidden">, book' +
                 (target ? ' (opens in a new tab)' : '') + '</span>' +
             '</a>';
    }

    function rowsMarkup(venues, bookable) {
      return venues.map(function (v) {
        var lines = v.lines.map(function (l) {
          return '<b>' + escapeHtml(l) + '</b>';
        }).join('');
        var note = v.note
          ? '<dd class="hours-panel__note">' + escapeHtml(v.note) + '</dd>'
          : '';
        return '<div class="hours-panel__row' + (v.shut ? ' is-shut' : '') + '">' +
                 '<dt>' + venueMarkup(v.venue, bookable) + '</dt>' +
                 '<dd class="hours-panel__times">' + lines + '</dd>' +
                 note +
               '</div>';
      }).join('');
    }

    // The all-hours link sits first, the phone in the middle and the address
    // last: the board above is one day, so the next thing reached for is the
    // rest of the week.
    //
    // The phone is the fallback for the day nobody entered a closure: the schedule
    // says open, the venue is full of a wedding, and the only thing that can
    // still help is somebody picking up. tel: so a phone dials it rather than
    // selecting it.
    //
    // Shown the way it's written in Australia, 03 5987 3800, rather than as
    // Settings > Store details holds it, +61 3 5987 3800. Dialled in
    // international form, as the footer and venue-hours.liquid dial it, so an
    // overseas phone gets through too. Either form in Store details gives the
    // same row.
    var phoneRow = '';
    if (data.phone) {
      var phoneText = String(data.phone).trim().replace(/^\+61\s*/, '0');
      var phoneDial = String(data.phone).replace(/[^0-9+]/g, '').replace(/^0/, '+61');
      phoneRow = '<a class="hours-panel__link hours-panel__link--phone" href="tel:' +
        escapeHtml(phoneDial) + '">' +
        '<em>' + escapeHtml(phoneText) + '</em><span>&#9742;</span></a>';
    }

    var links = '';
    if (phoneRow || data.addressUrl || data.hoursUrl) {
      links = '<div class="hours-panel__links">' +
        (data.hoursUrl
          ? '<a class="hours-panel__link hours-panel__link--all" href="' + escapeHtml(data.hoursUrl) + '">' +
              '<em>All Opening Hours</em><span>&#8250;</span></a>'
          : '') +
        phoneRow +
        (data.addressUrl
          ? '<a class="hours-panel__link" href="' + escapeHtml(data.addressUrl) + '" target="_blank" rel="noopener">' +
              '<em>' + escapeHtml(data.addressLabel || 'Find us') + '</em><span>&#8599;</span>' +
              '<span class="visually-hidden"> (opens in a new tab)</span></a>'
          : '') +
        '</div>';
    }

    // The arrows sit together at the right, so they stay put while the label
    // changes length from day to day; either side of the label, the right one
    // would move with every step. aria-disabled rather than disabled at either
    // end, so a keyboard user's focus stays on the arrow instead of dropping
    // to the page. The arrows are drawn in CSS, as the drawer's open and close
    // chevron is, so the two read as one set.
    //
    // Away from today the day is a button back to it: two weeks out is
    // thirteen taps the other way. On today it's disabled, as there is
    // nowhere to go. The live region is its own span, so a step reads out
    // the day and not the button's "back to today".
    var head = '<div class="hours-panel__head">' +
                 '<p class="hours-panel__day">' +
                   '<button type="button" class="hours-panel__today" data-hours-today disabled>' +
                     '<span data-hours-day></span>' +
                     '<span class="visually-hidden" data-hours-back hidden>, back to today</span>' +
                   '</button>' +
                 '</p>' +
                 '<span class="visually-hidden" aria-live="polite" data-hours-said></span>' +
                 '<span class="hours-panel__steps">' +
                   '<button type="button" class="hours-panel__step hours-panel__step--back" data-hours-step="-1" aria-label="Previous day"></button>' +
                   '<button type="button" class="hours-panel__step hours-panel__step--on" data-hours-step="1" aria-label="Next day"></button>' +
                 '</span>' +
               '</div>';

    document.querySelectorAll('[data-hours-panel]').forEach(function (panel) {
      panel.innerHTML = head + '<dl class="hours-panel__list"></dl>' + links;

      var offset = 0;
      var label = panel.querySelector('[data-hours-day]');
      var said = panel.querySelector('[data-hours-said]');
      var today = panel.querySelector('[data-hours-today]');
      var backNote = panel.querySelector('[data-hours-back]');
      var list = panel.querySelector('.hours-panel__list');
      var back = panel.querySelector('[data-hours-step="-1"]');
      var on = panel.querySelector('[data-hours-step="1"]');
      var bookable = !panel.classList.contains('hours-panel--drawer');

      // announce is false for the reset as the panel opens, which nobody
      // asked to hear.
      function show(next, announce) {
        offset = Math.max(0, Math.min(HOURS_AHEAD, next));
        var date = offset ? HoursEngine.addDays(state.date, offset) : state.date;
        label.innerHTML = dayLabelMarkup(date, offset);
        if (announce) said.textContent = dayLabel(date, offset);
        list.innerHTML = rowsMarkup(venuesOn(offset), bookable);
        // The day button is disabled on today; focus on it would drop to the
        // page, so it moves to the next arrow first.
        if (!offset && document.activeElement === today) on.focus();
        today.disabled = !offset;
        backNote.hidden = !offset;
        back.setAttribute('aria-disabled', offset === 0 ? 'true' : 'false');
        on.setAttribute('aria-disabled', offset === HOURS_AHEAD ? 'true' : 'false');
      }
      show(0);

      panel.addEventListener('click', function (event) {
        if (event.target.closest('[data-hours-today]')) {
          if (offset) show(0, true);
          return;
        }
        var step = event.target.closest('[data-hours-step]');
        if (!step || step.getAttribute('aria-disabled') === 'true') return;
        show(offset + Number(step.getAttribute('data-hours-step')), true);
      });

      // Every opening starts on today. Reset as it opens, not as it closes,
      // so the board doesn't change under the fade out. Capture, so this runs
      // before the toggle's own handler marks it open, whichever was bound
      // first.
      var owner = panel.closest('[id]');
      var opener = owner && document.querySelector('[aria-controls="' + owner.id + '"]');
      if (opener) {
        opener.addEventListener('click', function () {
          if (opener.getAttribute('aria-expanded') !== 'true' && offset) show(0);
        }, true);
      }
    });
    // The line reads the same whatever the hours are. A label that changes as
    // you move between pages reads as something happening rather than as a
    // control, and what it would say is already in the panel a tap away.
    document.querySelectorAll('[data-hours-summary]').forEach(function (el) {
      el.textContent = 'Opening hours';
    });
    // Nothing to reveal: the markup only renders when the metaobjects exist,
    // so the line is already there and the panel is what gets filled. Left as
    // a safety net for a page that somehow ships it hidden.
    document.querySelectorAll('[data-hours-line][hidden]').forEach(function (line) {
      line.hidden = false;
    });

    // The dot is the one part of the line that claims anything, so it is the
    // one part that has to be right.
    document.querySelectorAll('.toolbar__hours__dot').forEach(function (dot) {
      dot.hidden = !state.openNow;
    });

    initHoursPopout();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // The toolbar's panel opens on click and closes on the next click anywhere
  // else, which is the pattern the theme's search popdown already uses: the
  // click lands on the underlay and cannot reach a link beneath it.
  // How far the panel has to fall past the toggle to reach the underside of
  // the toolbar.
  //
  // top: 100% is the toggle's own bottom edge, which is not the bar's. The
  // difference depends on the toolbar's font size and padding rather than on
  // anything the stylesheet declares, so it is measured rather than guessed,
  // and it can fall either way.
  //
  // Measured as the panel opens, and again on resize while it's open, since
  // the toolbar's size setting is per breakpoint. Not at load: the panel is
  // hidden until then, and measuring would force a layout on every page.
  function placeHoursPanel(toggle) {
    var bar = toggle.closest('[data-header-toolbar]') || toggle.closest('.toolbar');
    if (!bar) return;

    // The span, not the button inside it. top: 100% resolves against the
    // panel's containing block, which is .toolbar__hours, and the span is
    // taller than the button it holds: it stretches to the utilities row so
    // the label sits centred. Measuring the button would put the panel out by
    // exactly that difference.
    var anchor = toggle.parentElement;
    if (!anchor) return;
    var here = anchor.getBoundingClientRect();
    var bars = bar.getBoundingClientRect();
    if (!here.height || !bars.height) return;
    // Signed. The toggle can sit above the bar's bottom edge or below it
    // depending on how the utilities row lands, so this has to pull up as
    // readily as it pushes down. Clamped at zero, the panel could never come
    // back to a bar whose bottom is above the toggle's.
    var drop = Math.round(bars.bottom - here.bottom);
    anchor.style.setProperty('--hours-panel-drop', drop + 'px');
  }

  function initHoursPopout() {
    var toggle = document.querySelector('[data-hours-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { placeHoursPanel(toggle); }, 120);
    });

    function close() {
      toggle.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('data-open');
    }

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      var open = toggle.getAttribute('aria-expanded') === 'true';
      if (open) { close(); return; }
      placeHoursPanel(toggle);        // the bar can change height with the page
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('data-open', '');
    });

    panel.addEventListener('click', function (event) { event.stopPropagation(); });
    document.addEventListener('click', close);
    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  initHours();

  /* ----------------------------------------------------------------------
     The Hours page
     ---------------------------------------------------------------------- */

  /* The venue hours block prints each venue's week in Liquid, every season
   * listed with its dates, so the hours read without script and for anything
   * crawling the page. What depends on today is added here, from the same
   * engine as the popout: the season in force moves to the top and is tagged
   * Now, the next season follows it and the rest are hidden, today's row is
   * marked, and a season laid over another in the next six weeks is listed
   * at the top of the card. Pages are cached, which is why none of this is
   * worked out in Liquid. */
  var HOURS_PAGE_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  /* How far ahead the Hours page looks: notices list what starts within it,
   * and a next season starting within it shows open. */
  var HOURS_PAGE_AHEAD = 42;
  var HOURS_PAGE_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                           'July', 'August', 'September', 'October', 'November', 'December'];

  function initHoursPage() {
    var blocks = document.querySelectorAll('[data-venue-hours]');
    if (!blocks.length) return;

    var date = HoursEngine.localNow();
    var venues = [];
    var source = document.querySelector('[data-hours-data]');
    if (source) {
      try {
        venues = JSON.parse(source.textContent).venues || [];
      } catch (e) {
        venues = [];                           // the seasons still show without them
      }
    }

    var horizon = hoursDayNumber(HoursEngine.addDays(date, HOURS_PAGE_AHEAD));

    Array.prototype.forEach.call(blocks, function (block) {
      markHoursSeason(block, date);
      listHoursClosures(block, date, horizon);
      writeNextSeason(block, venues, date);
    });
  }

  function hoursDayNumber(date) {
    return date.year * 10000 + date.month * 100 + date.day;
  }

  /* The season in force on a date, by the engine's own rule: the last dated
   * block that covers it, otherwise the first block with no date line. A
   * venue out of season has neither. */
  function hoursSeasonOn(seasons, date) {
    var match = null;
    var fallback = null;
    seasons.forEach(function (season) {
      var from = parseInt(season.getAttribute('data-from'), 10);
      var to = parseInt(season.getAttribute('data-to'), 10);
      if (isNaN(from) || isNaN(to)) {
        if (!fallback) fallback = season;
        return;
      }
      if (HoursEngine.coversDate({ from: from, to: to }, date)) match = season;
    });
    return match || fallback;
  }

  /* A card's seasons in the order printed, not the order on screen: the
   * last dated one covering a day wins, and a card the theme editor did not
   * re-render has already been reordered. */
  function hoursSeasonList(block) {
    var seasons = Array.prototype.slice.call(block.querySelectorAll('[data-season]'));
    seasons.forEach(function (season, i) {
      if (!season.hasAttribute('data-order')) season.setAttribute('data-order', i);
    });
    return seasons.sort(function (a, b) {
      return a.getAttribute('data-order') - b.getAttribute('data-order');
    });
  }

  /* A season laid over part of another, the summer holidays inside summer:
   * dated, and every day of it inside a dated season printed before it,
   * walked through a leap year so 29 February counts. */
  function hoursIsOverlay(season, seasons) {
    var from = parseInt(season.getAttribute('data-from'), 10);
    var to = parseInt(season.getAttribute('data-to'), 10);
    if (isNaN(from) || isNaN(to)) return false;
    return seasons.slice(0, seasons.indexOf(season)).some(function (outer) {
      var range = { from: parseInt(outer.getAttribute('data-from'), 10), to: parseInt(outer.getAttribute('data-to'), 10) };
      if (isNaN(range.from) || isNaN(range.to)) return false;
      var day = { year: 2028, month: Math.floor(from / 100), day: from % 100, weekday: 0, minutes: 0 };
      for (var i = 0; i < 366; i++) {
        if (!HoursEngine.coversDate(range, day)) return false;
        if (day.month * 100 + day.day === to) return true;
        day = HoursEngine.addDays(day, 1);
      }
      return false;
    });
  }

  /* The season in force moves to the top and is tagged Now.
   *
   * On the Hours page's cards only it and the next season show, so a venue
   * with a run of short seasons still reads as two. The next is the
   * first season the engine puts in force on a later day, walked a day at a
   * time, so one that resumes after a season laid over it (summer after the
   * holidays) counts. A season laid over another is never the next one:
   * until it starts it is a line at the top of the card (listHoursClosures),
   * and while it's on it is the season in force.
   *
   * The seasons' own names (Summer hours) don't show on the cards: the
   * season in force reads Current hours, its dates under it, and the next
   * reads From and the day it takes over (From 9 November), with no dates.
   * A guest needs when the hours change, not what the season is called. The
   * rest stay printed, hidden, with their names, for no script and for
   * anything crawling the page. The venue pages' card shows only the first
   * season and the next-season line. */
  function markHoursSeason(block, date) {
    var seasons = hoursSeasonList(block);
    var overlays = seasons.filter(function (s) { return hoursIsOverlay(s, seasons); });

    var current = hoursSeasonOn(seasons, date);
    var compact = block.classList.contains('hc-hours--compact');
    var next = null;
    var nextFar = false;
    var nextFrom = '';

    if (!compact && seasons.length > 1) {
      for (var i = 1; i <= 366 && !next; i++) {
        var day = HoursEngine.addDays(date, i);
        var season = hoursSeasonOn(seasons, day);
        if (season && season !== current && overlays.indexOf(season) < 0) {
          next = season;
          nextFar = i > HOURS_PAGE_AHEAD;
          nextFrom = 'From ' + day.day + ' ' + HOURS_PAGE_MONTHS[day.month - 1];
        }
      }
      seasons.forEach(function (s) {
        s.hidden = s !== current && s !== next;
        hoursSeasonLabel(s, null);
      });
      if (next) {
        hoursSeasonHead(next, nextFrom, false);
        seasons[0].parentNode.insertBefore(next, seasons[0].parentNode.firstChild);
      }
      if (current && next) {
        hoursSeasonHead(current, 'Current hours', true);
        if (isNaN(parseInt(current.getAttribute('data-from'), 10))) {
          hoursSeasonLabel(current, hoursSeasonSpan(seasons, overlays, current, date));
        }
      }
      if (next && nextFar) hoursCloseSeason(next);
    }

    if (!current) return;

    // A card with no change coming (one season all year) still reads
    // Current hours with the Now tag, as every other card does.
    if (!compact && !next) hoursSeasonHead(current, 'Current hours', true);

    if (compact ? seasons.length > 1 : true) {
      var tag = current.querySelector('[data-now]');
      if (tag) tag.hidden = false;
      seasons[0].parentNode.insertBefore(current, seasons[0].parentNode.firstChild);
    }

    // Every line that holds today: a lunch and a dinner line can both.
    var rows = current.querySelectorAll('[data-days~="' + date.weekday + '"]');
    Array.prototype.forEach.call(rows, function (row) {
      row.classList.add('is-today');
      row.setAttribute('aria-current', 'date');
    });
  }

  /* A season's heading on the Hours page's cards: the name line reads name
   * and holds the Now tag, and its dates show under it or are taken out.
   * A season printed without a name gets a name line, and one printed with
   * no dates either (a single season with no date line) gets its Now tag
   * here. The printed name is kept on the line, so a later run can put it
   * back. */
  function hoursSeasonHead(season, name, keepDates) {
    var head = season.querySelector('.hc-season-name');
    var dates = season.querySelector('.hc-season-label');
    var tag = season.querySelector('[data-now]');
    if (!head) {
      head = document.createElement('p');
      head.className = 'hc-season-name';
      season.insertBefore(head, dates || season.firstChild);
    }
    if (!head.firstChild || head.firstChild.nodeType !== 3) head.insertBefore(document.createTextNode(''), head.firstChild);
    if (!head.hasAttribute('data-name-text')) head.setAttribute('data-name-text', head.firstChild.nodeValue);
    head.firstChild.nodeValue = name + ' ';
    if (!tag) {
      tag = document.createElement('span');
      tag.className = 'hc-now';
      tag.setAttribute('data-now', '');
      tag.hidden = true;
      tag.textContent = 'Now';
    }
    if (tag) head.appendChild(tag);
    if (dates && !keepDates) dates.parentNode.removeChild(dates);
  }

  /* The dates of a season with no date line (the Rest of the year), as the
   * engine puts it in force around today: from the day after the season
   * before it ends to the day before the next starts. Seasons laid over
   * another are left out, so the holidays don't cut it short. */
  function hoursSeasonSpan(seasons, overlays, current, date) {
    var outer = seasons.filter(function (s) { return overlays.indexOf(s) < 0; });
    var first = date;
    var last = date;
    for (var i = 1; i <= 366; i++) {
      var back = HoursEngine.addDays(date, -i);
      if (hoursSeasonOn(outer, back) !== current) break;
      first = back;
    }
    for (var j = 1; j <= 366; j++) {
      var ahead = HoursEngine.addDays(date, j);
      if (hoursSeasonOn(outer, ahead) !== current) break;
      last = ahead;
    }
    return first.day + ' ' + HOURS_PAGE_MONTHS[first.month - 1] + ' to ' +
           last.day + ' ' + HOURS_PAGE_MONTHS[last.month - 1];
  }

  /* A next season that starts further off than the notices look ahead is
   * one line, its name and From date, that opens to its rows: most of the
   * year the season in force is all a guest needs, and the card stays
   * short. The name and label move into the summary as spans (a summary
   * holds phrasing content only), keeping their classes and attributes. */
  function hoursCloseSeason(season) {
    if (season.querySelector('.hc-season-more')) return;
    var details = document.createElement('details');
    var summary = document.createElement('summary');
    var head = document.createElement('span');
    var icon = document.createElement('span');
    details.className = 'hc-season-more';
    head.className = 'hc-season-head';
    icon.className = 'hc-special-icon';
    icon.setAttribute('aria-hidden', 'true');
    Array.prototype.forEach.call(season.querySelectorAll('.hc-season-name, .hc-season-label'), function (p) {
      var span = document.createElement('span');
      Array.prototype.forEach.call(p.attributes, function (a) { span.setAttribute(a.name, a.value); });
      while (p.firstChild) span.appendChild(p.firstChild);
      head.appendChild(span);
      p.parentNode.removeChild(p);
    });
    summary.appendChild(head);
    summary.appendChild(icon);
    details.appendChild(summary);
    while (season.firstChild) details.appendChild(season.firstChild);
    season.appendChild(details);
  }

  /* A season's label as printed (text null), or in its place. The printed
   * text is kept on the label, so a later run can put it back. */
  function hoursSeasonLabel(season, text) {
    var label = season.querySelector('.hc-season-label');
    var node = label && label.firstChild;
    if (!node || node.nodeType !== 3) return;
    if (!label.hasAttribute('data-label')) label.setAttribute('data-label', node.nodeValue);
    node.nodeValue = text === null ? label.getAttribute('data-label') : text + ' ';
  }

  /* The venue pages' card: the next change of season in one line, under the
   * season in force. Which season comes next depends on the date, so it is
   * written here rather than in Liquid. The date is the first day the engine
   * puts a different block in force, walked a day at a time, so overlapping
   * seasons (the holidays inside summer) come out as they will happen. Only
   * the change is named: days that open, days that close, a sitting that
   * changes, or later or shorter hours. */
  var HOURS_DAY_SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  function writeNextSeason(block, venues, date) {
    var slot = block.querySelector('[data-hours-next]');
    if (!slot) return;
    slot.textContent = '';

    var name = String(block.getAttribute('data-venue') || '').trim().toLowerCase();
    var venue = null;
    venues.forEach(function (v) {
      if (String(v.venue || '').trim().toLowerCase() === name) venue = v;
    });
    if (!venue) return;

    var blocks = HoursEngine.parseSchedule(venue.hours);
    var current = HoursEngine.blockFor(blocks, date);
    if (!current) return;

    for (var i = 1; i <= 366; i++) {
      var day = HoursEngine.addDays(date, i);
      var next = HoursEngine.blockFor(blocks, day);
      // A block with the same week as this one changes nothing a guest sees.
      if (next === current || (next && JSON.stringify(next.week) === JSON.stringify(current.week))) continue;
      if (!next) return;                       // the season ends with nothing after it
      var change = hoursChange(current, next, venue.bySitting === true);
      var when = day.day === 1
        ? HOURS_PAGE_MONTHS[day.month - 1]
        : day.day + ' ' + HOURS_PAGE_MONTHS[day.month - 1];
      slot.textContent = change + ' from ' + when;
      return;
    }
  }

  /* Days in a set, as venue-hours-days.liquid writes them: Every day,
   * Fri to Tue, Wed and Thu. Runs wrap around the week. */
  function hoursDaysLabel(set, lower) {
    if (set.every(Boolean)) return lower ? 'every day' : 'Every day';
    var start = -1;
    for (var i = 0; i < 7; i++) {
      if (start < 0 && set[i] && !set[(i + 6) % 7]) start = i;
    }
    if (start < 0) return '';
    var runs = [];
    var runStart = -1;
    var runLen = 0;
    for (var k = 0; k <= 7; k++) {
      var d = (start + k) % 7;
      if (k < 7 && set[d]) {
        if (!runLen) runStart = d;
        runLen++;
      } else if (runLen) {
        var end = (runStart + runLen - 1) % 7;
        runs.push(runLen === 1 ? HOURS_DAY_SHORT[runStart]
          : HOURS_DAY_SHORT[runStart] + (runLen === 2 ? ' and ' : ' to ') + HOURS_DAY_SHORT[end]);
        runLen = 0;
      }
    }
    return runs.join(', ');
  }

  /* The days a block opens, for one sitting or the whole day. A range that
   * opens before 5pm is lunch and one at 5pm or later dinner, as
   * venue-hours.liquid reads them; one that opens before 5pm and runs past
   * 6pm is both. */
  function hoursOpenDays(block, sitting) {
    return block.week.map(function (ranges) {
      if (!ranges) return false;
      if (!sitting) return true;
      return ranges.some(function (r) {
        return sitting === 'Dinner' ? r.open >= 1020 || r.close > 1080 : r.open < 1020;
      });
    });
  }

  /* By sitting when either season has a day of two, or the venue has
   * Read by sitting ticked, as venue-hours.liquid decides. */
  function hoursChange(current, next, sittingVenue) {
    var bySitting = !!sittingVenue || [current, next].some(function (b) {
      return b.week.some(function (ranges) { return ranges && ranges.length > 1; });
    });
    var sittings = bySitting ? ['Lunch', 'Dinner'] : [''];
    var any = function (set) { return set.some(Boolean); };

    // Days that open: Lunch every day, Every day.
    var gained = [];
    sittings.forEach(function (s) {
      var now = hoursOpenDays(current, s);
      var then = hoursOpenDays(next, s);
      if (any(then.map(function (on, d) { return on && !now[d]; }))) gained.push({ sitting: s, days: then });
    });
    if (gained.length === 2 && String(gained[0].days) === String(gained[1].days)) {
      return 'Lunch and dinner ' + hoursDaysLabel(gained[0].days, true);
    }
    if (gained.length) {
      return gained.map(function (g, i) {
        if (!g.sitting) return hoursDaysLabel(g.days);
        return (i ? g.sitting.toLowerCase() : g.sitting) + ' ' + hoursDaysLabel(g.days, true);
      }).join(', ');
    }

    // Whole days that close: Closed Wed and Thu.
    var openNow = hoursOpenDays(current, '');
    var openThen = hoursOpenDays(next, '');
    var closing = openNow.map(function (on, d) { return on && !openThen[d]; });
    if (any(closing)) return 'Closed ' + hoursDaysLabel(closing);

    // A sitting on fewer days: Dinner Fri and Sat.
    for (var i = 0; i < sittings.length; i++) {
      if (!sittings[i]) continue;
      var a = hoursOpenDays(current, sittings[i]);
      var b = hoursOpenDays(next, sittings[i]);
      if (String(a) !== String(b)) {
        return any(b) ? sittings[i] + ' ' + hoursDaysLabel(b, true) : 'No ' + sittings[i].toLowerCase();
      }
    }

    // The same days, later or earlier closes: Later Fri and Sat.
    var later = [];
    var earlier = [];
    for (var d = 0; d < 7; d++) {
      var c = current.week[d];
      var n = next.week[d];
      var cClose = c ? c[c.length - 1].close : 0;
      var nClose = n ? n[n.length - 1].close : 0;
      later.push(!!(c && n && nClose > cClose));
      earlier.push(!!(c && n && nClose < cClose));
    }
    if (any(later) && !any(earlier)) return 'Later ' + hoursDaysLabel(later);
    if (any(earlier) && !any(later)) return 'Shorter hours ' + hoursDaysLabel(earlier);

    // The same closes, earlier or later opens: Opens earlier Sat.
    var sooner = [];
    var after = [];
    for (var o = 0; o < 7; o++) {
      var co = current.week[o];
      var no = next.week[o];
      sooner.push(!!(co && no && no[0].open < co[0].open));
      after.push(!!(co && no && no[0].open > co[0].open));
    }
    if (any(sooner) && !any(after)) return 'Opens earlier ' + hoursDaysLabel(sooner);
    if (any(after) && !any(sooner)) return 'Opens later ' + hoursDaysLabel(after);
    return 'Hours change';
  }

  /* "Friday 5 March", or "Fri 5 March" short, for a row beside its hours. */
  function hoursDateLabel(dayNumber, short) {
    var year = Math.floor(dayNumber / 10000);
    var month = Math.floor(dayNumber / 100) % 100;
    var day = dayNumber % 100;
    var weekday = (new Date(Date.UTC(year, month - 1, day)).getUTCDay() + 6) % 7;
    return (short ? HOURS_DAY_SHORT : HOURS_PAGE_DAYS)[weekday] + ' ' + day + ' ' + HOURS_PAGE_MONTHS[month - 1];
  }

  /* The days from one day number to another, both included, up to eight:
   * enough to tell a span of a week or less from a longer one. */
  function hoursDaysBetween(from, to) {
    var out = [];
    var t = Date.UTC(Math.floor(from / 10000), Math.floor(from / 100) % 100 - 1, from % 100);
    var n = from;
    while (n <= to && out.length < 8) {
      out.push(n);
      t += 86400000;
      var d = new Date(t);
      n = d.getUTCFullYear() * 10000 + (d.getUTCMonth() + 1) * 100 + d.getUTCDate();
    }
    return out;
  }

  /* "Saturday 13 March, from 5pm", or "Friday 12 March to Sunday 14 March". */
  function hoursClosureWhen(c) {
    var from = hoursDateLabel(c.from.day);
    var to = hoursDateLabel(c.to.day);
    var fromTime = c.from.minutes > 0;
    var toTime = c.to.minutes < 1439;
    var label = HoursEngine.timeLabel;

    if (c.from.day === c.to.day) {
      if (fromTime && toTime) return from + ', ' + label(c.from.minutes) + ' to ' + label(c.to.minutes);
      if (fromTime) return from + ', from ' + label(c.from.minutes);
      if (toTime) return from + ', until ' + label(c.to.minutes);
      return from;
    }
    return (fromTime ? label(c.from.minutes) + ' ' : '') + from + ' to ' +
           (toTime ? label(c.to.minutes) + ' ' : '') + to;
  }

  /* The notices at the top of a card: a season laid over another (the
   * summer holidays), from six weeks before it starts. Its name in bold,
   * then its dates and the rows printed for it, closed until opened. Without
   * a name its dates stand in. Once it starts it is the season in force
   * instead (markHoursSeason). Closures and Special hours don't show on the
   * Hours page: the popout gives them on the day. The venue pages' compact
   * hours print no list. */
  function listHoursClosures(block, date, horizon) {
    var list = block.querySelector('[data-closures]');
    if (!list) return;

    var specials = [];
    var seasons = hoursSeasonList(block);
    var current = hoursSeasonOn(seasons, date);
    seasons.forEach(function (season) {
      if (season === current || !hoursIsOverlay(season, seasons)) return;
      for (var i = 1; i <= 366; i++) {
        var day = HoursEngine.addDays(date, i);
        if (hoursDayNumber(day) > horizon) return;
        if (hoursSeasonOn(seasons, day) !== season) continue;
        var label = season.querySelector('.hc-season-label');
        var when = label ? String(label.getAttribute('data-label') || (label.firstChild && label.firstChild.nodeValue) || '').trim() : '';
        var name = season.getAttribute('data-name');
        var rows = season.querySelector('.hc-season-days');
        specials.push({
          from: { day: hoursDayNumber(day), minutes: 0 },
          html: '<li class="hc-closure hc-special"><details><summary>' +
                '<span class="hc-special-name">' + escapeHtml(name || when) + '</span>' +
                '<span class="hc-special-icon" aria-hidden="true"></span></summary>' +
                (name && when ? '<p class="hc-season-label">' + escapeHtml(when) + '</p>' : '') +
                '<dl class="hc-season-days">' + (rows ? rows.innerHTML : '') + '</dl></details></li>'
        });
        return;
      }
    });
    var coming = specials.sort(function (a, b) {
      return a.from.day - b.from.day;
    });

    if (!coming.length) {
      list.innerHTML = '';
      list.hidden = true;
      return;
    }

    list.innerHTML = coming.map(function (item) { return item.html; }).join('');
    list.hidden = false;
  }

  initHoursPage();
  // The theme editor re-renders a section in place when a setting changes,
  // which would lose the marks above until the next full page load.
  document.addEventListener('shopify:section:load', initHoursPage);

  /* ----------------------------------------------------------------------
     Product photos on phones
     ---------------------------------------------------------------------- */

  /* On a phone the product photos are a native scroller, one photo across
   * the screen at a time, with a dot per photo under them (product.liquid
   * prints the dots with the first marked). This moves the mark to whichever
   * photo is more than half on screen, by observer, so nothing runs on
   * scroll. A section the theme editor re-renders arrives with new dots,
   * which get their own observer. */
  function initProductSlideDots() {
    if (!('IntersectionObserver' in window)) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-slide-dots]'), function (dots) {
      if (dots.hasAttribute('data-slide-dots-ready')) return;
      var images = dots.closest('product-images');
      var list = images && images.querySelector('[data-product-media-list]');
      if (!list) return;
      dots.setAttribute('data-slide-dots-ready', '');

      var slides = Array.prototype.slice.call(list.querySelectorAll('[data-slide]'));
      var marks = dots.children;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.5) return;
          var index = slides.indexOf(entry.target);
          Array.prototype.forEach.call(marks, function (mark, i) {
            mark.classList.toggle('is-active', i === index);
          });
        });
      }, { root: list, threshold: 0.5 });
      slides.forEach(function (slide) { observer.observe(slide); });
    });
  }

  initProductSlideDots();
  document.addEventListener('shopify:section:load', initProductSlideDots);

  /* ----------------------------------------------------------------------
     Event and experience photos
     ---------------------------------------------------------------------- */

  /* The photos on an event or experience page are one native scroller, a
   * photo wide (snippets/whats-on-photos.liquid). This marks the dot of the
   * photo more than half on screen, by observer as the product page's dots
   * are, so nothing runs on scroll, and fades the arrow that can't move.
   * An arrow scrolls by the strip's width, which is read on the click, and
   * the snap settles it on the photo. The second photo starts loading once
   * the page has loaded, so the first swipe doesn't wait for it; the rest
   * as soon as anyone hovers, touches, focuses or scrolls the strip. A
   * section the theme editor re-renders arrives as a new strip and gets its
   * own observer. */
  function initWhatsOnPhotos() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wod-photos]'), function (root) {
      if (root.hasAttribute('data-wod-photos-ready')) return;
      var strip = root.querySelector('.wod__photos');
      var slides = strip ? Array.prototype.slice.call(strip.children) : [];
      if (slides.length < 2) return;
      root.setAttribute('data-wod-photos-ready', '');

      var prev = root.querySelector('[data-wod-photos-prev]');
      var next = root.querySelector('[data-wod-photos-next]');
      var dots = root.parentNode.querySelector('[data-wod-photos-dots]');
      var marks = dots ? dots.children : [];
      var current = 0;

      function mark(index) {
        if (index < 0) return;
        current = index;
        Array.prototype.forEach.call(marks, function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        if (prev) prev.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
        if (next) next.setAttribute('aria-disabled', index === slides.length - 1 ? 'true' : 'false');
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio >= 0.5) mark(slides.indexOf(entry.target));
          });
        }, { root: strip, threshold: 0.5 });
        slides.forEach(function (slide) { observer.observe(slide); });
      }

      function loadFrom(from) {
        slides.slice(from).forEach(function (slide) {
          var img = slide.querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        });
      }
      function loadAll() {
        loadFrom(1);
        ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
          root.removeEventListener(type, loadAll);
        });
        strip.removeEventListener('scroll', loadAll);
      }
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
        root.addEventListener(type, loadAll, { passive: true });
      });
      strip.addEventListener('scroll', loadAll, { passive: true });
      function loadSecond() {
        var img = slides[1].querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }
      if (document.readyState === 'complete') loadSecond();
      else window.addEventListener('load', loadSecond, { once: true });

      function go(step) {
        var target = current + step;
        if (target < 0 || target > slides.length - 1) return;
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        strip.scrollBy({ left: step * strip.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
    });
  }

  initWhatsOnPhotos();
  document.addEventListener('shopify:section:load', initWhatsOnPhotos);

  /* ----------------------------------------------------------------------
     Wine cards: the cut-out bottles
     ---------------------------------------------------------------------- */

  /* Every cut-out bottle the same size. A cut-out PNG with empty space round
   * its bottle would stand smaller and higher than a trimmed one. When a
   * cut-out photo loads, its bottle's outline is read from the image's
   * transparency (a small canvas, once per file) and custom.css scales and
   * moves it to the drawn height, centred, its foot on its shadow:
   * --bottle-scale, --bottle-x and --bottle-below on the img. A transform,
   * so nothing else on the page moves. A pack of bottles side by side
   * stands the same way, at the same height: is-pack on the photo's layer
   * (custom.css stands a card's pack clear above the round + and runs its
   * shadow the pack's width). Every bottle's layer takes --scene-span, its
   * width over its height, which sizes its shadow on the card and on the
   * product page (one width for every bottle would run the line well past
   * a slim bottle's foot), and is-clear when its foot is pale, clear glass
   * with a pale wine in it, which custom.css gives a lighter shadow. Every
   * bottle is measured, even one trimmed close to its file: unmeasured, a
   * bottle filling its file to within 2% can stand up to 1% of its height
   * above its shadow.
   * Left as it is: anything wider than tall (it would run past the box at
   * that height), a landscape file, a bottle under half its file's height
   * (upscaled, it would blur: trim the file), and a file from another
   * domain that a canvas may not read (a preview link reads a copy, see
   * localCopy).
   *
   * One listener for every image load, in the capture phase as theme.js's
   * own: a photo is measured in the same task the theme shows it in, so it
   * is first drawn at its final size. Photos that had loaded before this
   * script ran are measured at once. The shop's feature tile draws its
   * bottle the same way when the wine has no Feature photo: it has no
   * photo layer, so only the img's three values apply there. The product
   * page's cut-out bottle (product.liquid) does too, its photo box standing
   * in for the card's layer.
   *
   * Most bottles are measured ahead of time: tools/bottle_shapes.py runs
   * outline() below on every bottle photo in the store and writes the
   * values into snippets/bottle-shape.liquid, which the card, the feature
   * tile and the product page print on the layer with data-bottle. Those
   * are skipped here; this measures only a photo the list doesn't have yet,
   * such as a new wine's, until the tool runs again. */
  function initBottleTrim() {
    var selector = '.product-item--cutout .product-item__bg .image-wrapper img, .shop-feature__bottle .image-wrapper img, .product__photo--cutout .image-wrapper img';
    var shapes = new Map();
    var waiting = new Map();
    var canvas = null;
    var context = null;

    // The bottle's outline as fractions of its file, or null to leave it.
    // Pixels at least half opaque count; a row or column needs two of them,
    // so a stray speck doesn't widen the outline.
    function outline(source) {
      var width = source.naturalWidth;
      var height = source.naturalHeight;
      if (!width || !height || width > height) return null;
      var rows = Math.min(200, height);
      var cols = Math.max(1, Math.round(rows * width / height));
      if (!canvas) {
        canvas = document.createElement('canvas');
        context = canvas.getContext('2d', { willReadFrequently: true });
      }
      if (!context) return null;
      canvas.width = cols;
      canvas.height = rows;
      context.clearRect(0, 0, cols, rows);
      context.drawImage(source, 0, 0, cols, rows);
      var alpha = context.getImageData(0, 0, cols, rows).data;
      var inRow = new Uint16Array(rows);
      var inCol = new Uint16Array(cols);
      for (var y = 0; y < rows; y++) {
        for (var x = 0; x < cols; x++) {
          if (alpha[(y * cols + x) * 4 + 3] >= 128) {
            inRow[y]++;
            inCol[x]++;
          }
        }
      }
      var top = 0;
      var bottom = rows - 1;
      var left = 0;
      var right = cols - 1;
      while (top < rows && inRow[top] < 2) top++;
      while (bottom > top && inRow[bottom] < 2) bottom--;
      while (left < cols && inCol[left] < 2) left++;
      while (right > left && inCol[right] < 2) right--;
      if (top >= rows || left >= cols) return null;

      // How pale the foot is: the mean lightness of the opaque pixels in the
      // bottle's lowest 4% (alpha holds the whole reading, colour too). Clear
      // glass with a pale wine in it reads 135 to 150 of 255, every other
      // bottle in the range 90 or less.
      var footRows = Math.max(2, Math.round((bottom - top) * 0.04));
      var footLight = 0;
      var footCount = 0;
      for (var fy = bottom - footRows + 1; fy <= bottom; fy++) {
        for (var fx = left; fx <= right; fx++) {
          var at = (fy * cols + fx) * 4;
          if (alpha[at + 3] >= 200) {
            footLight += 0.2126 * alpha[at] + 0.7152 * alpha[at + 1] + 0.0722 * alpha[at + 2];
            footCount++;
          }
        }
      }

      // The foot again, finer, as the shadow's line is drawn there: read at
      // 200 rows alone, a foot could stand off it by half a percent of the
      // bottle's height, about 1.5px on a card and 3px on the product page. A
      // band a few rows deep across the bottle's width, drawn eight times
      // taller: an img's natural size, which this reading is in, is for a
      // srcset photo about the size it's drawn at, not the file's. The whole
      // photo is drawn, magnified and moved so only the band lands on the
      // canvas: a source rectangle would be read in the file's own pixels
      // instead, and miss the band.
      var step = height / rows;
      var colStep = width / cols;
      var x0 = Math.max(0, (left - 1) * colStep);
      var x1 = Math.min(width, (right + 2) * colStep);
      var y0 = Math.max(0, (bottom - 1) * step);
      var y1 = Math.min(height, (bottom + 3) * step);
      var bandWidth = Math.max(1, Math.round((x1 - x0) * 2));
      var bandHeight = Math.max(1, Math.round((y1 - y0) * 8));
      var footEdge = (bottom + 1) * step;
      var scaleX = bandWidth / (x1 - x0);
      var scaleY = bandHeight / (y1 - y0);
      canvas.width = bandWidth;
      canvas.height = bandHeight;
      context.clearRect(0, 0, bandWidth, bandHeight);
      context.drawImage(source, -x0 * scaleX, -y0 * scaleY, width * scaleX, height * scaleY);
      var band = context.getImageData(0, 0, bandWidth, bandHeight).data;
      for (var by = bandHeight - 1; by >= 0; by--) {
        var opaque = 0;
        for (var bx = 0; bx < bandWidth && opaque < 2; bx++) {
          if (band[(by * bandWidth + bx) * 4 + 3] >= 128) opaque++;
        }
        if (opaque >= 2) {
          footEdge = y0 + (by + 1) * (y1 - y0) / bandHeight;
          break;
        }
      }

      var fill = (footEdge - top * step) / height;
      var below = (height - footEdge) / height;
      var centre = (left + right + 1) / 2 / cols;
      var shape = ((right + 1 - left) / cols * width) / (fill * height);
      if (shape > 1 || fill < 0.5) return null;
      // Wider than 0.6 of its height, it's a pack. Over 110, the foot is
      // clear glass.
      return {
        scale: 1 / fill,
        below: below,
        centre: centre,
        span: shape,
        pack: shape > 0.6,
        clear: footCount > 0 && footLight / footCount > 110
      };
    }

    function apply(img, found) {
      var layer = img.closest('.product-item__bg, .product__photo--cutout');
      if (found) {
        img.style.setProperty('--bottle-scale', found.scale.toFixed(4));
        img.style.setProperty('--bottle-below', found.below.toFixed(4));
        img.style.setProperty('--bottle-x', found.centre.toFixed(4));
      } else {
        img.style.removeProperty('--bottle-scale');
        img.style.removeProperty('--bottle-below');
        img.style.removeProperty('--bottle-x');
      }
      if (layer && found) {
        layer.style.setProperty('--scene-span', found.span.toFixed(3));
      } else if (layer) {
        layer.style.removeProperty('--scene-span');
      }
      if (layer) {
        layer.classList.toggle('is-pack', Boolean(found && found.pack));
        layer.classList.toggle('is-clear', Boolean(found && found.clear));
      }
    }

    function settle(key, found) {
      shapes.set(key, found);
      (waiting.get(key) || []).forEach(function (img) { apply(img, found); });
      waiting.delete(key);
    }

    // Shopify serves the photos under /cdn/shop/ on the store's own domain.
    // On a preview link that is another domain, which a canvas may not read,
    // so the outline is read from a copy on the domain the page is on.
    function localCopy(src) {
      var url = new URL(src, window.location.href);
      if (url.origin !== window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0) {
        return window.location.origin + url.pathname + url.search;
      }
      return null;
    }

    function check(img) {
      var src = img.currentSrc || img.src;
      if (!src || !img.naturalWidth) return;
      var key = src.split('?')[0];
      if (shapes.has(key)) {
        apply(img, shapes.get(key));
        return;
      }
      if (waiting.has(key)) {
        waiting.get(key).push(img);
        return;
      }
      waiting.set(key, [img]);
      try {
        settle(key, outline(img));
      } catch (error) {
        var copySrc = localCopy(src);
        if (!copySrc) {
          settle(key, null);
          return;
        }
        var copy = new Image();
        copy.onload = function () {
          var found = null;
          try {
            found = outline(copy);
          } catch (copyError) {
            found = null;
          }
          settle(key, found);
        };
        copy.onerror = function () { settle(key, null); };
        copy.src = copySrc;
      }
    }

    // A bottle in a section more than a screen away is measured as that
    // section comes within a screen of view, not as the photo loads: reading
    // a photo costs about 50ms on a slowed phone, and lazy cards load well
    // ahead of view, so measuring them all at load holds up the page while
    // it is still settling. The section is watched rather than the photo, as
    // a card off to the side in a scrolling row never counts as in view
    // until it is scrolled to, which would show it unscaled. A bottle within
    // a screen is measured at once, as above.
    var ahead = null;
    var pending = new Map();
    if ('IntersectionObserver' in window) {
      ahead = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          ahead.unobserve(entry.target);
          var imgs = pending.get(entry.target) || [];
          pending.delete(entry.target);
          imgs.forEach(check);
        });
      }, { rootMargin: '100% 0px' });
    }

    function measure(img) {
      // Measured ahead of time (snippets/bottle-shape.liquid): the layer
      // already carries the values.
      if (img.closest('[data-bottle]')) return;
      var section = ahead && img.closest('.shopify-section');
      if (!section) { check(img); return; }
      var box = section.getBoundingClientRect();
      var screen = window.innerHeight;
      if (box.bottom > -screen && box.top < screen * 2) { check(img); return; }
      if (!pending.has(section)) {
        pending.set(section, []);
        ahead.observe(section);
      }
      pending.get(section).push(img);
    }

    document.addEventListener('load', function (event) {
      var img = event.target;
      if (img.tagName === 'IMG' && img.matches(selector)) measure(img);
    }, true);

    Array.prototype.forEach.call(document.querySelectorAll(selector), function (img) {
      if (img.complete) measure(img);
    });
  }

  initBottleTrim();

  // Search suggestions ask for products only. Shopify returns up to ten
  // suggestions shared across products, collections, pages and search
  // phrases, and predictive-search.liquid shows only the products, so the
  // other types would take places from the wines. theme.js builds the request
  // and isn't edited (it adds ?q= to the route itself, so the route can't
  // carry the parameters): its request is caught here and given them. Only
  // that request changes: Shopify's suggest address with section_id
  // predictive-search, without a type already set.
  function initProductSuggestions() {
    if (!window.fetch || !window.URL) return;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      if (typeof input === 'string' && input.indexOf('section_id=predictive-search') !== -1) {
        try {
          var url = new URL(input, location.href);
          var route = window.theme && window.theme.routes && window.theme.routes.predictive_search_url;
          if (route && url.pathname === new URL(route, location.href).pathname && !url.searchParams.has('resources[type]')) {
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '10');
            input = url.pathname + url.search;
          }
        } catch (error) {}
      }
      return nativeFetch.call(window, input, init);
    };
  }

  initProductSuggestions();


  // A tap shows what a hover shows. A finger has no hover, so the link or
  // control a finger presses takes is-pressed, and custom.css and the
  // sections style that as their hover: the label goes gold, a photo zooms.
  // It replaces the browser's tap flash, a blue box in no part of the
  // palette, which custom.css turns off.
  //
  // Not :active. iOS applies :active only under a touch listener, and then
  // from the first touch, so a scroll that starts on a link lights it up.
  // This shows the press after the finger rests 100ms, as Android's own
  // press does, or as it lifts on a quick tap, and drops it the moment the
  // touch becomes a scroll or a swipe: the browser sends pointercancel when
  // it takes the touch over, and a carousel that pans for itself is caught
  // by the finger moving past 10px. It comes off 350ms after the finger
  // lifts, the hover's own easing time, so a quick tap reaches the full
  // state before fading back. Touch only: a mouse hovers, and a pen over a
  // tablet hovers too. One set of passive listeners on the document; no
  // layout reads.
  function initPressState() {
    if (!window.PointerEvent) return;

    var pressable = 'a[href], button, summary, label, [role="button"], input[type="submit"], input[type="button"]';
    var slop = 10;
    var pressed = null;
    var startX = 0;
    var startY = 0;
    var showTimer = 0;
    var clearTimer = 0;

    function release() {
      clearTimeout(showTimer);
      clearTimeout(clearTimer);
      if (pressed) pressed.classList.remove('is-pressed');
      pressed = null;
    }

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'touch' || !event.isPrimary) return;
      release();
      var target = event.target.closest ? event.target.closest(pressable) : null;
      if (!target) return;
      pressed = target;
      startX = event.clientX;
      startY = event.clientY;
      showTimer = setTimeout(function () {
        if (pressed === target) target.classList.add('is-pressed');
      }, 100);
    }, { passive: true });

    document.addEventListener('pointermove', function (event) {
      if (!pressed || event.pointerType !== 'touch' || !event.isPrimary) return;
      if (Math.abs(event.clientX - startX) > slop || Math.abs(event.clientY - startY) > slop) release();
    }, { passive: true });

    document.addEventListener('pointerup', function (event) {
      if (!pressed || event.pointerType !== 'touch' || !event.isPrimary) return;
      var target = pressed;
      clearTimeout(showTimer);
      target.classList.add('is-pressed');
      clearTimer = setTimeout(function () {
        target.classList.remove('is-pressed');
        if (pressed === target) pressed = null;
      }, 350);
    }, { passive: true });

    document.addEventListener('pointercancel', release, { passive: true });
    document.addEventListener('contextmenu', release);

    // A page restored from the back-forward cache comes back as it was
    // left, so a press still showing when the next page opened is cleared.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) release();
    });
  }

  initPressState();


  // Klaviyo draws the contact form's message as a one-line field, and Enter
  // in a one-line field sends its form, so a guest starting a new line after
  // "Hi," sent the message. Enter does nothing in that field; the form sends
  // from its button. The listener sits on the form's holder, which the page
  // prints before Klaviyo fills it, in the capture phase so it runs before
  // the form's own handlers. The field is found by its Klaviyo property,
  // contact_message, which Klaviyo puts at the start of its id.
  function initKlaviyoMessageEnter() {
    var holders = document.querySelectorAll('.shopify-app-block [class*="klaviyo-form-"]');
    for (var i = 0; i < holders.length; i++) {
      holders[i].addEventListener('keydown', function (event) {
        var field = event.target;
        if (event.key === 'Enter' && field.tagName === 'INPUT' && field.id.indexOf('contact_message') === 0) {
          event.preventDefault();
        }
      }, true);
    }
  }

  initKlaviyoMessageEnter();


  // Klaviyo's dropdowns (the contact form's Enquiry type) filter their list by
  // the text in the box, and a choice puts its name in the box, so once one is
  // chosen the list shows that one alone and it can't be changed. Opening a
  // box that holds a choice (a click or tap, or the up or down arrow) clears
  // the text, so the whole list shows. Leaving without a new choice picks the
  // old one again: its text goes back, which narrows the list to it, and on
  // the next frame, once Klaviyo has drawn that list, the option is clicked as
  // a visitor would, and focus goes on to wherever the visitor went. Klaviyo
  // holds the text as its own state, so the text is set as typing would set
  // it, through the value setter and an input event. Listened for after
  // Klaviyo's handlers, on the form's holder.
  function initKlaviyoDropdownReopen() {
    var setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    var holders = document.querySelectorAll('.shopify-app-block [class*="klaviyo-form-"]');

    function setText(input, text) {
      setValue.call(input, text);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function isDropdown(el) {
      return el && el.matches && el.matches('input[role="combobox"]');
    }

    for (var i = 0; i < holders.length; i++) {
      (function (holder) {
        var chosen = '';

        function showAll(event) {
          var input = event.target;
          if (!isDropdown(input) || !input.value) return;
          if (event.type === 'keydown' && event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          if (input.getAttribute('aria-expanded') !== 'true') return;
          chosen = input.value;
          setText(input, '');
        }

        holder.addEventListener('click', showAll);
        holder.addEventListener('keydown', showAll);

        holder.addEventListener('focusout', function (event) {
          var input = event.target;
          if (!isDropdown(input) || !chosen) return;
          var keep = chosen;
          chosen = '';
          setTimeout(function () {
            if (input.value) return;
            var away = document.activeElement;
            setText(input, keep);
            requestAnimationFrame(function () {
              var menu = document.getElementById(input.getAttribute('aria-controls'));
              var options = menu ? menu.querySelectorAll('[role="option"]') : [];
              for (var j = 0; j < options.length; j++) {
                if (options[j].textContent.trim() === keep.trim()) {
                  options[j].click();
                  break;
                }
              }
              if (document.activeElement === input && away !== input) {
                if (away && away !== document.body) away.focus();
                else input.blur();
              }
            });
          }, 0);
        });
      })(holders[i]);
    }
  }

  initKlaviyoDropdownReopen();


  // The contact form's message as a box several lines tall, where Enter starts
  // a new line. Klaviyo draws the message as a one-line field (its property
  // contact_message, at the start of the field's id), which can't hold a line
  // break. A textarea goes in after it and the field is hidden from view and
  // from Tab, but stays the one Klaviyo reads: each change in the box is typed
  // into it, line breaks as spaces, through the value setter and an input
  // event, so Klaviyo's required check and its state follow the box. When
  // Klaviyo sends the form (an XHR carrying JSON), the message in it is
  // swapped for the box's own text, line breaks kept. If that swap fails, the
  // message still arrives, as one line. A focus Klaviyo gives the field (its
  // error check) goes on to the box. The box goes in as soon as Klaviyo draws
  // the field, watched for on the form's holder only, before the next frame
  // is drawn, so nothing below it moves later.
  function initKlaviyoMessageBox() {
    var holders = document.querySelectorAll('.shopify-app-block [class*="klaviyo-form-"]');
    if (!holders.length || !window.MutationObserver) return;
    var setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    var lastBox = null;

    function attach(input) {
      input.setAttribute('data-message-box', '');
      input.setAttribute('tabindex', '-1');
      input.setAttribute('aria-hidden', 'true');

      var box = document.createElement('textarea');
      box.className = 'klaviyo-message-box';
      box.rows = 5;
      box.placeholder = input.placeholder;
      box.value = input.value;
      box.setAttribute('aria-required', input.getAttribute('aria-required') || 'false');
      var label = input.id && document.querySelector('label[for="' + input.id + '"]');
      if (label && label.id) box.setAttribute('aria-labelledby', label.id);
      input.insertAdjacentElement('afterend', box);

      box.addEventListener('input', function () {
        lastBox = box;
        setValue.call(input, box.value.replace(/\s*[\r\n]+\s*/g, ' '));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
      box.addEventListener('blur', function () {
        input.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
      });
      input.addEventListener('focus', function () {
        box.focus();
      });
    }

    function sync(holder) {
      var inputs = holder.querySelectorAll('input[id^="contact_message"]');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (!input.hasAttribute('data-message-box')) attach(input);
        var box = input.nextElementSibling;
        var invalid = input.getAttribute('aria-invalid') || 'false';
        // Set only on a change: the observer below watches this attribute too.
        if (box && box.classList.contains('klaviyo-message-box') && box.getAttribute('aria-invalid') !== invalid) {
          box.setAttribute('aria-invalid', invalid);
        }
      }
    }

    for (var i = 0; i < holders.length; i++) {
      (function (holder) {
        sync(holder);
        new MutationObserver(function () { sync(holder); }).observe(holder, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-invalid']
        });
      })(holders[i]);
    }

    function withMessage(value, text) {
      if (!value || typeof value !== 'object') return;
      for (var key in value) {
        if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
        if (key === 'contact_message' && typeof value[key] === 'string') value[key] = text;
        else withMessage(value[key], text);
      }
    }

    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      if (lastBox && typeof body === 'string' && body.indexOf('"contact_message"') !== -1 && /[\r\n]/.test(lastBox.value)) {
        try {
          var data = JSON.parse(body);
          withMessage(data, lastBox.value.trim());
          body = JSON.stringify(data);
        } catch (error) {}
      }
      return send.call(this, body);
    };
  }

  initKlaviyoMessageBox();


  // Every newsletter sign-up (the footer's, a Newsletter section's) sends
  // without leaving the page. Sent the usual way, the page reloads at the
  // top and theme.js scrolls back down to the form half a second later.
  // Here the form posts in the background, and the form in the page Shopify
  // answers with, holding its thank-you or its error, takes the old one's
  // place, so the page stays where it was. An answer without the form in
  // either state opens the page Shopify sent it to, as before; Shopify's
  // spam check (its challenge page), an answer that wasn't a redirect or a
  // failed request sends the form the usual way. Listened for on the
  // document in the capture phase, so it runs before newsletter.js, which
  // would reload the page.
  function initNewsletterSubmit() {
    if (!window.fetch || !window.FormData || !window.DOMParser) return;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[data-newsletter-form]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.getAttribute('aria-busy') === 'true') return;

      var id = form.getAttribute('id');
      var button = form.querySelector('[type="submit"]');
      form.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;

      function sendAsUsual() {
        HTMLFormElement.prototype.submit.call(form);
      }

      fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok || response.url.indexOf('/challenge') !== -1) {
            sendAsUsual();
            return;
          }
          return response.text().then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
            if (!fresh || !/(^|\s)has-(success|error)(\s|$)/.test(fresh.className)) {
              if (response.redirected) location.assign(response.url);
              else sendAsUsual();
              return;
            }
            form.className = fresh.className;
            form.innerHTML = fresh.innerHTML;
            form.removeAttribute('aria-busy');
            var message = form.querySelector('.newsletter__message--success');
            var target = message || form.querySelector('[data-newsletter-field]');
            if (target) target.focus({ preventScroll: true });
          });
        })
        .catch(sendAsUsual);
    }, true);
  }

  initNewsletterSubmit();


  // Bookings from Meta ads. SevenRooms counts a booking against the tracking
  // code on the link that was pressed, so a visitor who arrived from a Meta
  // ad is counted as the ad's, not as the button's placement. The landing
  // address carries utm_source=facebook (any case, any medium: the paid
  // campaigns and the midweek lunch campaign tagged Social); fbclid isn't
  // used, as organic post shares carry it too. The visit is held for 7 days,
  // Meta's click window, and a new landing from an ad starts it again.
  // While it holds, a booking link takes its venue's Meta code as it is
  // pressed or reached by keyboard, so links drawn later (the phone menu,
  // the hours panel) and links opened in a new tab are covered. The rest of
  // its query stays, Google's _gl included. Everyone else costs one address
  // check and one storage read.
  function initMetaAdsBooking() {
    var KEY = 'crittenden_meta_ads';
    var HOLD_MS = 7 * 24 * 60 * 60 * 1000;
    var CODES = { crittenden: 'meta-ads', crittendencellardoor: 'meta-ads-cd' };
    var now = Date.now();
    var since;

    try {
      var source = new URLSearchParams(window.location.search).get('utm_source');
      if (source && source.toLowerCase() === 'facebook') {
        localStorage.setItem(KEY, String(now));
        since = now;
      } else {
        since = parseInt(localStorage.getItem(KEY), 10);
      }
    } catch (error) {
      return;
    }
    if (!since || now - since > HOLD_MS) return;

    function retag(event) {
      var link = event.target && event.target.closest &&
        event.target.closest('a[href*="sevenrooms.com/explore/"]');
      if (!link) return;
      var url;
      try {
        url = new URL(link.href);
      } catch (error) {
        return;
      }
      var venue = url.pathname.match(/^\/explore\/([^\/]+)\//);
      var code = venue && CODES[venue[1]];
      if (!code || url.searchParams.get('tracking') === code) return;
      url.searchParams.set('tracking', code);
      link.href = url.toString();
    }

    document.addEventListener('pointerdown', retag, { capture: true, passive: true });
    document.addEventListener('focusin', retag, true);
  }

  initMetaAdsBooking();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

